import { definePreset } from '@primeng/themes';
import Lara from '@primeng/themes/lara';

export const Fingerpeg = definePreset(Lara, {
    primitive: {
        borderRadius: {
            none: '0',
            xs: '0',
            sm: '0',
            md: '0',
            lg: '0',
            xl: '0',
        },
        emerald: {
            '50': '#edfcf5',
            '100': '#d1fae5',
            '200': '#a6f2d1',
            '300': '#6ee8b8',
            '400': '#33d499',
            '500': '#0fba82',
            '600': '#059669',
            '700': '#057857',
            '800': '#055e45',
            '900': '#054f3b',
            '950': '#032b21',
        },
        green: {
            '50': '#f0fcf5',
            '100': '#dbfce8',
            '200': '#baf7d1',
            '300': '#87f0ab',
            '400': '#4ade80',
            '500': '#21c45e',
            '600': '#17a34a',
            '700': '#14803d',
            '800': '#176633',
            '900': '#14542e',
            '950': '#052e17',
        },
        lime: {
            '50': '#f7ffe8',
            '100': '#edfccc',
            '200': '#d9fa9e',
            '300': '#bff263',
            '400': '#a3e536',
            '500': '#85cc17',
            '600': '#66a30d',
            '700': '#4d7d0f',
            '800': '#406112',
            '900': '#365414',
            '950': '#1a2e05',
        },
        red: {
            '50': '#fff2f2',
            '100': '#ffe3e3',
            '200': '#ffc9c9',
            '300': '#fca6a6',
            '400': '#f77070',
            '500': '#f04545',
            '600': '#db2626',
            '700': '#ba1c1c',
            '800': '#991c1c',
            '900': '#801c1c',
            '950': '#450a0a',
        },
        orange: {
            '50': '#fff7ed',
            '100': '#ffedd6',
            '200': '#ffd6ab',
            '300': '#fcba73',
            '400': '#fa913d',
            '500': '#fa7317',
            '600': '#eb590d',
            '700': '#c2400d',
            '800': '#993312',
            '900': '#7d2e12',
            '950': '#421408',
        },
        amber: {
            '50': '#fffaeb',
            '100': '#fff2c7',
            '200': '#fce58a',
            '300': '#fcd44d',
            '400': '#fabf24',
            '500': '#f59e0a',
            '600': '#d97805',
            '700': '#b5540a',
            '800': '#91400d',
            '900': '#78360f',
            '950': '#451a03',
        },
        yellow: {
            '50': '#fffce8',
            '100': '#fffac2',
            '200': '#fff08a',
            '300': '#fce047',
            '400': '#facc14',
            '500': '#ebb208',
            '600': '#c98a05',
            '700': '#a16108',
            '800': '#854d0d',
            '900': '#704012',
            '950': '#422105',
        },

        teal: {
            '50': '#f0fcfa',
            '100': '#ccfaf2',
            '200': '#99f5e3',
            '300': '#5eebd4',
            '400': '#2ed4bf',
            '500': '#14b8a6',
            '600': '#0d9487',
            '700': '#0f756e',
            '800': '#125e59',
            '900': '#124f4a',
            '950': '#052e2e',
        },
        cyan: {
            '50': '#edffff',
            '100': '#cffaff',
            '200': '#a6f2fc',
            '300': '#66e8fa',
            '400': '#21d4ed',
            '500': '#05b5d4',
            '600': '#0891b2',
            '700': '#0d738f',
            '800': '#145e75',
            '900': '#174f63',
            '950': '#083345',
        },
        sky: {
            '50': '#f0faff',
            '100': '#e0f2ff',
            '200': '#bae5fc',
            '300': '#7dd4fc',
            '400': '#38bdf7',
            '500': '#0da6e8',
            '600': '#0385c7',
            '700': '#0369a1',
            '800': '#085985',
            '900': '#0d4a6e',
            '950': '#082e4a',
        },

        blue: {
            '50': '#f0f5ff',
            '100': '#dbebff',
            '200': '#bfdbff',
            '300': '#94c4fc',
            '400': '#61a6fa',
            '500': '#3b82f5',
            '600': '#2663eb',
            '700': '#1c4fd9',
            '800': '#1f40b0',
            '900': '#1f3b8a',
            '950': '#172654',
        },
        indigo: {
            '50': '#edf2ff',
            '100': '#e0e8ff',
            '200': '#c7d1ff',
            '300': '#a6b5fc',
            '400': '#828cf7',
            '500': '#6366f2',
            '600': '#4f45e5',
            '700': '#4238c9',
            '800': '#3830a3',
            '900': '#302e82',
            '950': '#1f1c4a',
        },

        violet: {
            '50': '#f5f2ff',
            '100': '#ede8ff',
            '200': '#ded6ff',
            '300': '#c4b5fc',
            '400': '#a68cfa',
            '500': '#8c5cf5',
            '600': '#7d3bed',
            '700': '#6e29d9',
            '800': '#5c21b5',
            '900': '#4d1c94',
            '950': '#2e0f66',
        },
        purple: {
            '50': '#faf5ff',
            '100': '#f2e8ff',
            '200': '#e8d6ff',
            '300': '#d9b5ff',
            '400': '#bf85fc',
            '500': '#a854f7',
            '600': '#9433eb',
            '700': '#7d21cf',
            '800': '#6b21a8',
            '900': '#591c87',
            '950': '#3b0863',
        },
        fuchsia: {
            '50': '#fcf5ff',
            '100': '#fae8ff',
            '200': '#f5d1ff',
            '300': '#f0abfc',
            '400': '#e878fa',
            '500': '#d945f0',
            '600': '#bf26d4',
            '700': '#a31cb0',
            '800': '#871a8f',
            '900': '#701a75',
            '950': '#4a054f',
        },
        pink: {
            '50': '#fcf2f7',
            '100': '#fce8f2',
            '200': '#facfe8',
            '300': '#faa8d4',
            '400': '#f573b5',
            '500': '#ed4799',
            '600': '#db2678',
            '700': '#bf175c',
            '800': '#9e174d',
            '900': '#821742',
            '950': '#4f0824',
        },

        rose: {
            '50': '#fff2f2',
            '100': '#ffe3e5',
            '200': '#ffccd4',
            '300': '#fca3b0',
            '400': '#fa7085',
            '500': '#f5405e',
            '600': '#e01c47',
            '700': '#bf123d',
            '800': '#9e1238',
            '900': '#871238',
            '950': '#4d051a',
        },
        slate: {
            '50': '#f7fafc',
            '100': '#f2f5fa',
            '200': '#e3e8f0',
            '300': '#ccd6e0',
            '400': '#94a3b8',
            '500': '#63738c',
            '600': '#475469',
            '700': '#334054',
            '800': '#1f293b',
            '900': '#0f1729',
            '950': '#030517',
        },
        gray: {
            '50': '#fafafa',
            '100': '#f2f5f5',
            '200': '#e5e8eb',
            '300': '#d1d6db',
            '400': '#9ca3b0',
            '500': '#6b7380',
            '600': '#4a5463',
            '700': '#384052',
            '800': '#1f2938',
            '900': '#121726',
            '950': '#030812',
        },
        zinc: {
            '50': '#fafafa',
            '100': '#f5f5f5',
            '200': '#e3e3e8',
            '300': '#d4d4d9',
            '400': '#a1a1ab',
            '500': '#70707a',
            '600': '#52525c',
            '700': '#404045',
            '800': '#262629',
            '900': '#17171c',
            '950': '#0a0a0a',
        },

        neutral: {
            '50': '#fafafa',
            '100': '#f5f5f5',
            '200': '#e5e5e5',
            '300': '#d4d4d4',
            '400': '#a3a3a3',
            '500': '#737373',
            '600': '#525252',
            '700': '#404040',
            '800': '#262626',
            '900': '#171717',
            '950': '#0a0a0a',
        },
        stone: {
            '50': '#fafafa',
            '100': '#f5f5f5',
            '200': '#e8e5e3',
            '300': '#d6d4d1',
            '400': '#a8a39e',
            '500': '#78706b',
            '600': '#57544f',
            '700': '#45403d',
            '800': '#292624',
            '900': '#1c1a17',
            '950': '#0d0a0a',
        },
    },
    semantic: {
        transitionDuration: '0.25s',
        focusRing: {
            width: '0',
            style: 'none',
            color: 'transparent',
            offset: '0',
        },
        disabledOpacity: '0.5',
        iconSize: '10px',
        anchorGutter: '2px',
        primary: {
            50: '#FFF4ED',
            100: '#FFF4ED',
            200: '#FFC9A8',
            300: '#FFA471',
            400: '#FF6626',
            500: '#FE4D11',
            600: '#EF3307',
            700: '#C62108',
            800: '#9D1D0F',
            900: '#9D1D0F',
            950: '#440906',
        },
        formField: {
            paddingX: '11px',
            paddingY: '9.5px',
            sm: {
                fontSize: '14px',
                paddingX: '8px',
                paddingY: '6px',
            },
            lg: {
                fontSize: '16px',
                paddingX: '14px',
                paddingY: '14px',
            },
            borderRadius: '{border.radius.md}',
            focusRing: {
                width: '0',
                style: 'none',
                color: 'transparent',
                offset: '0',
                shadow: 'none',
            },
            transitionDuration: '{transition.duration}',
        },
        list: {
            padding: '0',
            gap: '0',
            header: {
                padding: '10px 12px 0 12px',
            },
            option: {
                padding: '10px 12px',
                borderRadius: '0',
            },
            optionGroup: {
                padding: '10px 12px',
                fontWeight: '600',
            },
        },
        content: {
            borderRadius: '{border.radius.md}',
        },
        mask: {
            transitionDuration: '0.25s',
        },
        navigation: {
            list: {
                padding: '0.5rem 0',
                gap: '0',
            },
            item: {
                padding: '0.625rem 1rem',
                borderRadius: '0',
                gap: '0.5rem',
            },
            submenuLabel: {
                padding: '0.625rem 1rem',
                fontWeight: '600',
            },
            submenuIcon: {
                size: '0.875rem',
            },
        },
        overlay: {
            select: {
                borderRadius: '{border.radius.md}',
                shadow: '0 2px 12px 0 rgba(0, 0, 0, 0.1)',
            },
            popover: {
                borderRadius: '{border.radius.md}',
                padding: '1rem',
                shadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
            },
            modal: {
                borderRadius: '{border.radius.xl}',
                padding: '1rem 1.5rem',
                shadow: '0 1px 3px rgba(0, 0, 0, 0.3)',
            },
            navigation: {
                shadow: '0 2px 12px 0 rgba(0, 0, 0, 0.1)',
            },
        },
        colorScheme: {
            light: {
                surface: {
                    0: '#F5F8F6',
                    50: '#DEE9E3',
                    100: '#BDD2C9',
                    200: '#95B3A7',
                    300: '#95B3A7',
                    400: '#6E9385',
                    500: '#54786B',
                    600: '#425F55',
                    700: '#374E46',
                    800: '#2F403B',
                    900: '#2B3834',
                    950: '#151E1C',
                },
                primary: {
                    color: '{primary.400}',
                    contrastColor: '#ffffff',
                    hoverColor: '{primary.600}',
                    activeColor: '{primary.700}',
                },
                highlight: {
                    background: '{primary.400}',
                    focusBackground: '{primary.500}',
                    color: '{neutral.50}',
                    focusColor: '{neutral.50}',
                },
                focusRing: {
                    shadow: '0 0 0 0.2rem {primary.200}',
                },
                mask: {
                    background: 'rgba(0, 0, 0, 0.50)',
                    color: '{surface.200}',
                },
                formField: {
                    background: '#fff',
                    disabledBackground: '#fff',
                    filledBackground: '{surface.50}',
                    filledHoverBackground: '{surface.50}',
                    filledFocusBackground: '{surface.0}',
                    borderColor: '#d9dedd',
                    hoverBorderColor: '#192f47',
                    focusBorderColor: '#192f47',
                    invalidBorderColor: '{red.400}',
                    color: '{surface.950}',
                    disabledColor: '{surface.500}',
                    placeholderColor: '#5C6D69',
                    invalidPlaceholderColor: '{red.600}',
                    floatLabelColor: '{surface.500}',
                    floatLabelFocusColor: '{primary.600}',
                    floatLabelActiveColor: '{surface.500}',
                    floatLabelInvalidColor: '{form.field.invalid.placeholder.color}',
                    iconColor: '{surface.900}',
                    shadow: 'none',
                },
                text: {
                    color: '{surface.950}',
                    hoverColor: '{surface.950}',
                    mutedColor: '{surface.800}',
                    hoverMutedColor: '{surface.700}',
                },
                content: {
                    background: '{surface.0}',
                    hoverBackground: '{surface.100}',
                    borderColor: '{surface.200}',
                    color: '{text.color}',
                    hoverColor: '{text.hover.color}',
                },
                overlay: {
                    select: {
                        background: '{neutral.50}',
                        borderColor: '{surface.600}',
                        color: '{text.color}',
                    },
                    popover: {
                        background: '#fff',
                        borderColor: '#d9dedd',
                        color: '{text.color}',
                    },
                    modal: {
                        background: '#fff',
                        borderColor: '#d9dedd',
                        color: '{text.color}',
                    },
                },
                list: {
                    option: {
                        focusBackground: '{gray.200}',
                        selectedBackground: '{highlight.background}',
                        selectedFocusBackground: '{highlight.focus.background}',
                        color: '{text.color}',
                        focusColor: '{text.hover.color}',
                        selectedColor: '{highlight.color}',
                        selectedFocusColor: '{highlight.focus.color}',
                        icon: {
                            color: '{surface.400}',
                            focusColor: '{surface.500}',
                        },
                    },
                    optionGroup: {
                        background: 'transparent',
                        color: '{text.color}',
                    },
                },
                navigation: {
                    item: {
                        focusBackground: '{surface.100}',
                        activeBackground: '{surface.100}',
                        color: '{text.color}',
                        focusColor: '{text.hover.color}',
                        activeColor: '{text.hover.color}',
                        icon: {
                            color: '{surface.400}',
                            focusColor: '{surface.500}',
                            activeColor: '{surface.500}',
                        },
                    },
                    submenuLabel: {
                        background: 'transparent',
                        color: '{text.color}',
                    },
                    submenuIcon: {
                        color: '{surface.400}',
                        focusColor: '{surface.500}',
                        activeColor: '{surface.500}',
                    },
                },
            },
            dark: {
                surface: {
                    0: '#f8f9fa',
                    50: 'rgb(245 245 245)',
                    100: '#fbfbfb',
                    200: '#f9f9f9',
                    300: '#f6f6f6',
                    400: '#f3f3f3',
                    500: '#f0f0f0', // body color
                    600: '#cccccc',
                    700: '#a8a8a8',
                    800: '#4e4e4e',
                    900: '#3a3e41', // text color
                    950: '#3c3c3c',
                },
                primary: {
                    color: '{primary.500}',
                    contrastColor: '#ffffff',
                    hoverColor: '{primary.600}',
                    activeColor: '{primary.700}',
                },
                highlight: {
                    background: '{primary.500}',
                    focusBackground: '{primary.500}',
                    color: '{neutral.50}',
                    focusColor: '{neutral.50}',
                },
                focusRing: {
                    shadow: '0 0 0 0.2rem {primary.200}',
                },
                mask: {
                    background: 'rgba(0, 0, 0, 0.50)',
                    color: '{surface.200}',
                },
                formField: {
                    background: '{surface.0}',
                    disabledBackground: '{surface.200}',
                    filledBackground: '{surface.50}',
                    filledHoverBackground: '{surface.50}',
                    filledFocusBackground: '{surface.0}',
                    borderColor: '#ddd',
                    hoverBorderColor: '#192f47',
                    focusBorderColor: '#192f47',
                    invalidBorderColor: '{red.400}',
                    color: '{surface.900}',
                    disabledColor: '{surface.500}',
                    placeholderColor: '{stone.500}',
                    invalidPlaceholderColor: '{red.600}',
                    floatLabelColor: '{surface.500}',
                    floatLabelFocusColor: '{primary.600}',
                    floatLabelActiveColor: '{surface.500}',
                    floatLabelInvalidColor: '{form.field.invalid.placeholder.color}',
                    iconColor: '{surface.900}',
                    shadow: 'none',
                },
                text: {
                    color: '{surface.900}',
                    hoverColor: '{surface.950}',
                    mutedColor: '{surface.800}',
                    hoverMutedColor: '{surface.700}',
                },
                content: {
                    background: '{surface.0}',
                    hoverBackground: '{surface.100}',
                    borderColor: '{surface.200}',
                    color: '{text.color}',
                    hoverColor: '{text.hover.color}',
                },
                overlay: {
                    select: {
                        background: '{neutral.50}',
                        borderColor: '{surface.600}',
                        color: '{text.color}',
                    },
                    popover: {
                        background: '#fff',
                        borderColor: '{surface.200}',
                        color: '{text.color}',
                    },
                    modal: {
                        background: '#fff',
                        borderColor: '{surface.200}',
                        color: '{text.color}',
                    },
                },
                list: {
                    option: {
                        focusBackground: '{gray.200}',
                        selectedBackground: '{highlight.background}',
                        selectedFocusBackground: '{highlight.focus.background}',
                        color: '{text.color}',
                        focusColor: '{text.hover.color}',
                        selectedColor: '{highlight.color}',
                        selectedFocusColor: '{highlight.focus.color}',
                        icon: {
                            color: '{surface.400}',
                            focusColor: '{surface.500}',
                        },
                    },
                    optionGroup: {
                        background: 'transparent',
                        color: '{text.color}',
                    },
                },
                navigation: {
                    item: {
                        focusBackground: '{surface.100}',
                        activeBackground: '{surface.100}',
                        color: '{text.color}',
                        focusColor: '{text.hover.color}',
                        activeColor: '{text.hover.color}',
                        icon: {
                            color: '{surface.400}',
                            focusColor: '{surface.500}',
                            activeColor: '{surface.500}',
                        },
                    },
                    submenuLabel: {
                        background: 'transparent',
                        color: '{text.color}',
                    },
                    submenuIcon: {
                        color: '{surface.400}',
                        focusColor: '{surface.500}',
                        activeColor: '{surface.500}',
                    },
                },
            },
        },
    },
    components: {
        accordion: {
            root: {
                transitionDuration: '{transition.duration}',
            },
            panel: {
                borderWidth: '0',
                borderColor: '{content.border.color}',
            },
            header: {
                color: '{text.muted.color}',
                hoverColor: '{text.color}',
                activeColor: '{text.color}',
                padding: '12px',
                fontWeight: '400',
                borderRadius: '0',
                borderWidth: '0',
                borderColor: '#D9DEDD',
                focusRing: {
                    width: '{focus.ring.width}',
                    style: '{focus.ring.style}',
                    color: '{focus.ring.color}',
                    offset: '{focus.ring.offset}',
                    shadow: 'inset {focus.ring.shadow}',
                },
                toggleIcon: {
                    color: '{text.muted.color}',
                    hoverColor: '{text.color}',
                    activeColor: '{text.color}',
                    activeHoverColor: '{text.color}',
                },
                first: {
                    topBorderRadius: '{content.border.radius}',
                    borderWidth: '1px',
                },
                last: {
                    bottomBorderRadius: '{content.border.radius}',
                    activeBottomBorderRadius: '0',
                },
            },
            content: {
                borderWidth: '0 1px 1px 1px',
                borderColor: '#D9DEDD',
                background: '#fff',
                color: '{text.color}',
                padding: '1rem',
            },
            colorScheme: {
                light: {
                    header: {
                        background: '#f5f5f5',
                        hoverBackground: '#eef0f0',
                        activeBackground: '#eef0f0',
                        activeHoverBackground: '#eef0f0',
                    },
                },
                dark: {
                    header: {
                        background: '{neutral.500}',
                        hoverBackground: '{neutral.400}',
                        activeBackground: '{neutral.500}',
                        activeHoverBackground: '{neutral.500}',
                    },
                },
            },
        },
        autocomplete: {
            root: {
                background: '{form.field.background}',
                disabledBackground: '{form.field.disabled.background}',
                filledBackground: '{form.field.filled.background}',
                filledHoverBackground: '{form.field.filled.hover.background}',
                filledFocusBackground: '{form.field.filled.focus.background}',
                borderColor: '{form.field.border.color}',
                hoverBorderColor: '{form.field.hover.border.color}',
                focusBorderColor: '{form.field.focus.border.color}',
                invalidBorderColor: '{form.field.invalid.border.color}',
                color: '{form.field.color}',
                disabledColor: '{form.field.disabled.color}',
                placeholderColor: '{form.field.placeholder.color}',
                shadow: '{form.field.shadow}',
                paddingX: '{form.field.padding.x}',
                paddingY: '{form.field.padding.y}',
                borderRadius: '{form.field.border.radius}',
                focusRing: {
                    width: '{form.field.focus.ring.width}',
                    style: '{form.field.focus.ring.style}',
                    color: '{form.field.focus.ring.color}',
                    offset: '{form.field.focus.ring.offset}',
                    shadow: '{form.field.focus.ring.shadow}',
                },
                transitionDuration: '{form.field.transition.duration}',
            },
            overlay: {
                background: '{overlay.select.background}',
                borderColor: '{overlay.select.border.color}',
                borderRadius: '{overlay.select.border.radius}',
                color: '{overlay.select.color}',
                shadow: '{overlay.select.shadow}',
            },
            list: {
                padding: '{list.padding}',
                gap: '{list.gap}',
            },
            option: {
                focusBackground: '{list.option.focus.background}',
                selectedBackground: '{list.option.selected.background}',
                selectedFocusBackground: '{list.option.selected.focus.background}',
                color: '{list.option.color}',
                focusColor: '{list.option.focus.color}',
                selectedColor: '{list.option.selected.color}',
                selectedFocusColor: '{list.option.selected.focus.color}',
                padding: '{list.option.padding}',
                borderRadius: '{list.option.border.radius}',
            },
            optionGroup: {
                background: '{list.option.group.background}',
                color: '{list.option.group.color}',
                fontWeight: '{list.option.group.font.weight}',
                padding: '{list.option.group.padding}',
            },
            dropdown: {
                width: '2.5rem',
                sm: {
                    width: '2rem',
                },
                lg: {
                    width: '3rem',
                },
                borderColor: '{form.field.border.color}',
                hoverBorderColor: '{form.field.border.color}',
                activeBorderColor: '{form.field.border.color}',
                borderRadius: '{form.field.border.radius}',
                focusRing: {
                    width: '{form.field.focus.ring.width}',
                    style: '{form.field.focus.ring.style}',
                    color: '{form.field.focus.ring.color}',
                    offset: '{form.field.focus.ring.offset}',
                    shadow: '{form.field.focus.ring.shadow}',
                },
            },
            chip: {
                borderRadius: '{border.radius.sm}',
            },
            emptyMessage: {
                padding: '{list.option.padding}',
            },
            colorScheme: {
                light: {
                    chip: {
                        focusBackground: '{surface.200}',
                        focusColor: '{surface.800}',
                    },
                    dropdown: {
                        background: '{surface.50}',
                        hoverBackground: '{surface.100}',
                        activeBackground: '{surface.200}',
                        color: '{surface.600}',
                        hoverColor: '{surface.700}',
                        activeColor: '{surface.800}',
                    },
                },
                dark: {
                    chip: {
                        focusBackground: '{surface.200}',
                        focusColor: '{surface.800}',
                    },
                    dropdown: {
                        background: '{surface.50}',
                        hoverBackground: '{surface.100}',
                        activeBackground: '{surface.200}',
                        color: '{surface.600}',
                        hoverColor: '{surface.700}',
                        activeColor: '{surface.800}',
                    },
                },
            },
        },
        avatar: {
            root: {
                width: '2rem',
                height: '2rem',
                fontSize: '1rem',
                background: '{content.border.color}',
                color: '{content.color}',
                borderRadius: '{content.border.radius}',
            },
            icon: {
                size: '1rem',
            },
            group: {
                borderColor: '{content.background}',
                offset: '-0.75rem',
            },
            lg: {
                width: '3rem',
                height: '3rem',
                fontSize: '1.5rem',
                icon: {
                    size: '1.5rem',
                },
                group: {
                    offset: '-1rem',
                },
            },
            xl: {
                width: '4rem',
                height: '4rem',
                fontSize: '2rem',
                icon: {
                    size: '2rem',
                },
            },
        },
        badge: {
            root: {
                borderRadius: '{border.radius.md}',
                padding: '0 0.5rem',
                fontSize: '0.75rem',
                fontWeight: '700',
                minWidth: '1.5rem',
                height: '1.5rem',
            },
            dot: {
                size: '0.5rem',
            },
            sm: {
                fontSize: '0.625rem',
                minWidth: '1.25rem',
                height: '1.25rem',
            },
            lg: {
                fontSize: '0.875rem',
                minWidth: '1.75rem',
                height: '1.75rem',
            },
            xl: {
                fontSize: '1rem',
                minWidth: '2rem',
                height: '2rem',
            },
            colorScheme: {
                light: {
                    primary: {
                        background: '{primary.color}',
                        color: '{primary.contrast.color}',
                    },
                    secondary: {
                        background: '{surface.500}',
                        color: '{surface.900}',
                    },
                    success: {
                        background: '{green.500}',
                        color: '{surface.0}',
                    },
                    info: {
                        background: '{sky.500}',
                        color: '{surface.0}',
                    },
                    warn: {
                        background: '{orange.500}',
                        color: '{surface.0}',
                    },
                    danger: {
                        background: '{red.500}',
                        color: '{surface.0}',
                    },
                    contrast: {
                        background: '{surface.950}',
                        color: '{surface.0}',
                    },
                },
                dark: {
                    primary: {
                        background: '{primary.color}',
                        color: '{primary.contrast.color}',
                    },
                    secondary: {
                        background: '{surface.500}',
                        color: '{surface.900}',
                    },
                    success: {
                        background: '{green.500}',
                        color: '{surface.0}',
                    },
                    info: {
                        background: '{sky.500}',
                        color: '{surface.0}',
                    },
                    warn: {
                        background: '{orange.500}',
                        color: '{surface.0}',
                    },
                    danger: {
                        background: '{red.500}',
                        color: '{surface.0}',
                    },
                    contrast: {
                        background: '{surface.950}',
                        color: '{surface.0}',
                    },
                },
            },
        },
        blockui: {
            root: {
                borderRadius: '{content.border.radius}',
            },
        },
        breadcrumb: {
            root: {
                padding: '0',
                background: 'none',
                gap: '10px',
                transitionDuration: '{transition.duration}',
            },
            item: {
                color: '{text.color}',
                hoverColor: '{primary.500}',
                borderRadius: '{content.border.radius}',
                gap: '{navigation.item.gap}',
                icon: {
                    color: '{navigation.item.icon.color}',
                    hoverColor: '{navigation.item.icon.focus.color}',
                },
                focusRing: {
                    width: '{focus.ring.width}',
                    style: '{focus.ring.style}',
                    color: '{focus.ring.color}',
                    offset: '{focus.ring.offset}',
                    shadow: '{focus.ring.shadow}',
                },
            },
            separator: {
                color: '{text.color}',
            },
            css: () => `
            .p-breadcrumb {
                margin-bottom:16px;
                    overflow-x: visible;
            }`,
        },
        button: {
            root: {
                borderRadius: '{form.field.border.radius}',
                roundedBorderRadius: '2rem',
                gap: '0.5rem',
                paddingX: '1rem',
                paddingY: '{form.field.padding.y}',
                iconOnlyWidth: '2.75rem',
                sm: {
                    fontSize: '{form.field.sm.font.size}',
                    paddingX: '{form.field.sm.padding.x}',
                    paddingY: '{form.field.sm.padding.y}',
                },
                lg: {
                    fontSize: '17.5px',
                    paddingX: '{form.field.lg.padding.x}',
                    paddingY: '{form.field.lg.padding.y}',
                },
                label: {
                    fontWeight: '500',
                },
                raisedShadow:
                    '0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12)',
                focusRing: {
                    width: '{form.field.focus.ring.width}',
                    style: '{form.field.focus.ring.style}',
                    offset: '{form.field.focus.ring.offset}',
                },
                badgeSize: '1rem',
                transitionDuration: '{form.field.transition.duration}',
            },
            colorScheme: {
                light: {
                    root: {
                        primary: {
                            background: '{primary.color}',
                            hoverBackground: '{primary.hover.color}',
                            activeBackground: '{primary.active.color}',
                            borderColor: '{primary.color}',
                            hoverBorderColor: '{primary.hover.color}',
                            activeBorderColor: '{primary.active.color}',
                            color: '#151e1c',
                            hoverColor: '#151e1c',
                            activeColor: '#151e1c',
                            focusRing: {
                                color: 'transparent',
                                shadow: '0 0 0 0.2rem {primary.200}',
                            },
                        },
                        secondary: {
                            background: '{stone.500}',
                            hoverBackground: '{stone.400}',
                            activeBackground: '{stone.400}',
                            borderColor: '{stone.500}',
                            hoverBorderColor: '{stone.200}',
                            activeBorderColor: '{stone.300}',
                            color: '{primary.contrast.color}',
                            hoverColor: '{primary.contrast.color}',
                            activeColor: '{primary.contrast.color}',
                            focusRing: {
                                color: 'transparent',
                                shadow: '0 0 0 0.2rem {surface.200}',
                            },
                        },
                        info: {
                            background: '{surface.0}',
                            hoverBackground: '{surface.100}',
                            activeBackground: '{surface.100}',
                            borderColor: '{form.field.border.color}',
                            hoverBorderColor: '{form.field.border.color}',
                            activeBorderColor: '{form.field.border.color}',
                            color: '{text.color}',
                            hoverColor: '{text.color}',
                            activeColor: '{text.color}',
                            focusRing: {
                                color: 'transparent',
                                shadow: '0 0 0 0.2rem {sky.200}',
                            },
                        },
                        success: {
                            background: '{green.500}',
                            hoverBackground: '{green.600}',
                            activeBackground: '{green.700}',
                            borderColor: '{green.500}',
                            hoverBorderColor: '{green.600}',
                            activeBorderColor: '{green.700}',
                            color: '#ffffff',
                            hoverColor: '#ffffff',
                            activeColor: '#ffffff',
                            focusRing: {
                                color: 'transparent',
                                shadow: '0 0 0 0.2rem {green.200}',
                            },
                        },
                        warn: {
                            background: '{orange.500}',
                            hoverBackground: '{orange.600}',
                            activeBackground: '{orange.700}',
                            borderColor: '{orange.500}',
                            hoverBorderColor: '{orange.600}',
                            activeBorderColor: '{orange.700}',
                            color: '#ffffff',
                            hoverColor: '#ffffff',
                            activeColor: '#ffffff',
                            focusRing: {
                                color: 'transparent',
                                shadow: '0 0 0 0.2rem {orange.200}',
                            },
                        },
                        help: {
                            background: '{purple.500}',
                            hoverBackground: '{purple.600}',
                            activeBackground: '{purple.700}',
                            borderColor: '{purple.500}',
                            hoverBorderColor: '{purple.600}',
                            activeBorderColor: '{purple.700}',
                            color: '#ffffff',
                            hoverColor: '#ffffff',
                            activeColor: '#ffffff',
                            focusRing: {
                                color: 'transparent',
                                shadow: '0 0 0 0.2rem {purple.200}',
                            },
                        },
                        danger: {
                            background: '{red.700}',
                            hoverBackground: '{red.600}',
                            activeBackground: '{red.600}',
                            borderColor: '{red.700}',
                            hoverBorderColor: '{red.700}',
                            activeBorderColor: '{red.700}',
                            color: '#EEF0F0',
                            hoverColor: '#EEF0F0',
                            activeColor: '#EEF0F0',
                            focusRing: {
                                color: 'transparent',
                                shadow: '0 0 0 0.2rem {red.200}',
                            },
                        },
                        contrast: {
                            background: '{surface.950}',
                            hoverBackground: '{surface.900}',
                            activeBackground: '{surface.800}',
                            borderColor: '{surface.950}',
                            hoverBorderColor: '{surface.900}',
                            activeBorderColor: '{surface.800}',
                            color: '{surface.0}',
                            hoverColor: '{surface.0}',
                            activeColor: '{surface.0}',
                            focusRing: {
                                color: 'transparent',
                                shadow: '0 0 0 0.2rem {surface.400}',
                            },
                        },
                    },
                    outlined: {
                        primary: {
                            hoverBackground: '{primary.50}',
                            activeBackground: '{primary.100}',
                            borderColor: '{primary.200}',
                            color: '{primary.color}',
                        },
                        secondary: {
                            hoverBackground: '{stone.50}',
                            activeBackground: '{stone.50}',
                            borderColor: '{stone.500}',
                            color: '{stone.500}',
                        },
                        success: {
                            hoverBackground: '{green.50}',
                            activeBackground: '{green.100}',
                            borderColor: '{green.200}',
                            color: '{green.500}',
                        },
                        info: {
                            hoverBackground: '{sky.50}',
                            activeBackground: '{sky.100}',
                            borderColor: '{sky.200}',
                            color: '{sky.500}',
                        },
                        warn: {
                            hoverBackground: '{orange.50}',
                            activeBackground: '{orange.100}',
                            borderColor: '{orange.200}',
                            color: '{orange.500}',
                        },
                        help: {
                            hoverBackground: '{purple.50}',
                            activeBackground: '{purple.100}',
                            borderColor: '{purple.200}',
                            color: '{purple.500}',
                        },
                        danger: {
                            hoverBackground: '{red.50}',
                            activeBackground: '{red.100}',
                            borderColor: '{red.200}',
                            color: '{red.500}',
                        },
                        contrast: {
                            hoverBackground: '{surface.50}',
                            activeBackground: '{surface.100}',
                            borderColor: '{surface.700}',
                            color: '{surface.950}',
                        },
                        plain: {
                            hoverBackground: '{surface.50}',
                            activeBackground: '{surface.100}',
                            borderColor: '{surface.200}',
                            color: '{surface.700}',
                        },
                    },
                    text: {
                        primary: {
                            hoverBackground: '{primary.50}',
                            activeBackground: '{primary.100}',
                            color: '{primary.color}',
                        },
                        secondary: {
                            hoverBackground: '#0d2f570a',
                            activeBackground: '{surface.200}',
                            color: '{surface.900}',
                        },
                        success: {
                            hoverBackground: '{green.50}',
                            activeBackground: '{green.100}',
                            color: '{green.500}',
                        },
                        info: {
                            hoverBackground: '{sky.50}',
                            activeBackground: '{sky.100}',
                            color: '{sky.500}',
                        },
                        warn: {
                            hoverBackground: '{orange.50}',
                            activeBackground: '{orange.100}',
                            color: '{orange.500}',
                        },
                        help: {
                            hoverBackground: '#0d2f5780',
                            activeBackground: '#0d2f5780',
                            color: '{neutral.50}',
                        },
                        danger: {
                            hoverBackground: '{red.50}',
                            activeBackground: '{red.100}',
                            color: '{red.500}',
                        },
                        contrast: {
                            hoverBackground: '{surface.50}',
                            activeBackground: '{surface.100}',
                            color: '{surface.950}',
                        },
                        plain: {
                            hoverBackground: '{surface.50}',
                            activeBackground: '{surface.100}',
                            color: '{surface.700}',
                        },
                    },
                    link: {
                        color: '{primary.color}',
                        hoverColor: '{primary.color}',
                        activeColor: '{primary.color}',
                    },
                },
                dark: {
                    root: {
                        primary: {
                            background: '{primary.color}',
                            hoverBackground: '{primary.hover.color}',
                            activeBackground: '{primary.active.color}',
                            borderColor: '{primary.color}',
                            hoverBorderColor: '{primary.hover.color}',
                            activeBorderColor: '{primary.active.color}',
                            color: '{primary.contrast.color}',
                            hoverColor: '{primary.contrast.color}',
                            activeColor: '{primary.contrast.color}',
                            focusRing: {
                                color: 'transparent',
                                shadow: '0 0 0 0.2rem {primary.200}',
                            },
                        },
                        secondary: {
                            background: '{stone.500}',
                            hoverBackground: '{stone.400}',
                            activeBackground: '{stone.400}',
                            borderColor: '{stone.500}',
                            hoverBorderColor: '{stone.200}',
                            activeBorderColor: '{stone.300}',
                            color: '{primary.contrast.color}',
                            hoverColor: '{primary.contrast.color}',
                            activeColor: '{primary.contrast.color}',
                            focusRing: {
                                color: 'transparent',
                                shadow: '0 0 0 0.2rem {surface.200}',
                            },
                        },
                        info: {
                            background: '{sky.500}',
                            hoverBackground: '{sky.600}',
                            activeBackground: '{sky.700}',
                            borderColor: '{sky.500}',
                            hoverBorderColor: '{sky.600}',
                            activeBorderColor: '{sky.700}',
                            color: '#ffffff',
                            hoverColor: '#ffffff',
                            activeColor: '#ffffff',
                            focusRing: {
                                color: 'transparent',
                                shadow: '0 0 0 0.2rem {sky.200}',
                            },
                        },
                        success: {
                            background: '{green.500}',
                            hoverBackground: '{green.600}',
                            activeBackground: '{green.700}',
                            borderColor: '{green.500}',
                            hoverBorderColor: '{green.600}',
                            activeBorderColor: '{green.700}',
                            color: '#ffffff',
                            hoverColor: '#ffffff',
                            activeColor: '#ffffff',
                            focusRing: {
                                color: 'transparent',
                                shadow: '0 0 0 0.2rem {green.200}',
                            },
                        },
                        warn: {
                            background: '{orange.500}',
                            hoverBackground: '{orange.600}',
                            activeBackground: '{orange.700}',
                            borderColor: '{orange.500}',
                            hoverBorderColor: '{orange.600}',
                            activeBorderColor: '{orange.700}',
                            color: '#ffffff',
                            hoverColor: '#ffffff',
                            activeColor: '#ffffff',
                            focusRing: {
                                color: 'transparent',
                                shadow: '0 0 0 0.2rem {orange.200}',
                            },
                        },
                        help: {
                            background: '{purple.500}',
                            hoverBackground: '{purple.600}',
                            activeBackground: '{purple.700}',
                            borderColor: '{purple.500}',
                            hoverBorderColor: '{purple.600}',
                            activeBorderColor: '{purple.700}',
                            color: '#ffffff',
                            hoverColor: '#ffffff',
                            activeColor: '#ffffff',
                            focusRing: {
                                color: 'transparent',
                                shadow: '0 0 0 0.2rem {purple.200}',
                            },
                        },
                        danger: {
                            background: '{red.500}',
                            hoverBackground: '{red.600}',
                            activeBackground: '{red.700}',
                            borderColor: '{red.500}',
                            hoverBorderColor: '{red.600}',
                            activeBorderColor: '{red.700}',
                            color: '#ffffff',
                            hoverColor: '#ffffff',
                            activeColor: '#ffffff',
                            focusRing: {
                                color: 'transparent',
                                shadow: '0 0 0 0.2rem {red.200}',
                            },
                        },
                        contrast: {
                            background: '{surface.950}',
                            hoverBackground: '{surface.900}',
                            activeBackground: '{surface.800}',
                            borderColor: '{surface.950}',
                            hoverBorderColor: '{surface.900}',
                            activeBorderColor: '{surface.800}',
                            color: '{surface.0}',
                            hoverColor: '{surface.0}',
                            activeColor: '{surface.0}',
                            focusRing: {
                                color: 'transparent',
                                shadow: '0 0 0 0.2rem {surface.400}',
                            },
                        },
                    },
                    outlined: {
                        primary: {
                            hoverBackground: '{primary.50}',
                            activeBackground: '{primary.100}',
                            borderColor: '{primary.200}',
                            color: '{primary.color}',
                        },
                        secondary: {
                            hoverBackground: '{stone.50}',
                            activeBackground: '{stone.50}',
                            borderColor: '{stone.500}',
                            color: '{stone.500}',
                        },
                        success: {
                            hoverBackground: '{green.50}',
                            activeBackground: '{green.100}',
                            borderColor: '{green.200}',
                            color: '{green.500}',
                        },
                        info: {
                            hoverBackground: '{sky.50}',
                            activeBackground: '{sky.100}',
                            borderColor: '{sky.200}',
                            color: '{sky.500}',
                        },
                        warn: {
                            hoverBackground: '{orange.50}',
                            activeBackground: '{orange.100}',
                            borderColor: '{orange.200}',
                            color: '{orange.500}',
                        },
                        help: {
                            hoverBackground: '{purple.50}',
                            activeBackground: '{purple.100}',
                            borderColor: '{purple.200}',
                            color: '{purple.500}',
                        },
                        danger: {
                            hoverBackground: '{red.50}',
                            activeBackground: '{red.100}',
                            borderColor: '{red.200}',
                            color: '{red.500}',
                        },
                        contrast: {
                            hoverBackground: '{surface.50}',
                            activeBackground: '{surface.100}',
                            borderColor: '{surface.700}',
                            color: '{surface.950}',
                        },
                        plain: {
                            hoverBackground: '{surface.50}',
                            activeBackground: '{surface.100}',
                            borderColor: '{surface.200}',
                            color: '{surface.700}',
                        },
                    },
                    text: {
                        primary: {
                            hoverBackground: '{primary.50}',
                            activeBackground: '{primary.100}',
                            color: '{primary.color}',
                        },
                        secondary: {
                            hoverBackground: '#0d2f570a',
                            activeBackground: '{surface.200}',
                            color: '{surface.900}',
                        },
                        success: {
                            hoverBackground: '{green.50}',
                            activeBackground: '{green.100}',
                            color: '{green.500}',
                        },
                        info: {
                            hoverBackground: '{sky.50}',
                            activeBackground: '{sky.100}',
                            color: '{sky.500}',
                        },
                        warn: {
                            hoverBackground: '{orange.50}',
                            activeBackground: '{orange.100}',
                            color: '{orange.500}',
                        },
                        help: {
                            hoverBackground: '#0d2f5780',
                            activeBackground: '#0d2f5780',
                            color: '{neutral.50}',
                        },
                        danger: {
                            hoverBackground: '{red.50}',
                            activeBackground: '{red.100}',
                            color: '{red.500}',
                        },
                        contrast: {
                            hoverBackground: '{surface.50}',
                            activeBackground: '{surface.100}',
                            color: '{surface.950}',
                        },
                        plain: {
                            hoverBackground: '{surface.50}',
                            activeBackground: '{surface.100}',
                            color: '{surface.700}',
                        },
                    },
                    link: {
                        color: '{primary.color}',
                        hoverColor: '{primary.color}',
                        activeColor: '{primary.color}',
                    },
                },
            },
        },
        datepicker: {
            root: {
                transitionDuration: '{transition.duration}',
            },
            panel: {
                background: '#fff',
                borderColor: 'transparent',
                color: '{content.color}',
                borderRadius: '{content.border.radius}',
                shadow: '{overlay.popover.shadow}',
                padding: '0',
            },
            header: {
                background: '#fff',
                borderColor: 'transparent   ',
                color: '{content.color}',
                padding: '0',
            },
            title: {
                gap: '0.5rem',
                fontWeight: '600',
            },
            dropdown: {
                width: '2.5rem',
                sm: {
                    width: '2rem',
                },
                lg: {
                    width: '3rem',
                },
                borderColor: '{form.field.border.color}',
                hoverBorderColor: '{form.field.border.color}',
                activeBorderColor: '{form.field.border.color}',
                borderRadius: '{form.field.border.radius}',
                focusRing: {
                    width: '{form.field.focus.ring.width}',
                    style: '{form.field.focus.ring.style}',
                    color: '{form.field.focus.ring.color}',
                    offset: '{form.field.focus.ring.offset}',
                    shadow: '{form.field.focus.ring.shadow}',
                },
            },
            inputIcon: {
                color: '{form.field.icon.color}',
            },
            selectMonth: {
                hoverBackground: 'transparent',
                color: '{content.color}',
                hoverColor: '{content.color}',
                padding: '0.375rem 0.625rem',
                borderRadius: '{content.border.radius}',
            },
            selectYear: {
                hoverBackground: 'transparent',
                color: '{content.color}',
                hoverColor: '{content.color}',
                padding: '0.375rem 0.625rem',
                borderRadius: '{content.border.radius}',
            },
            group: {
                borderColor: '{content.border.color}',
                gap: '{overlay.popover.padding}',
            },
            dayView: {
                margin: ' 0',
            },
            weekDay: {
                padding: '0',
                fontWeight: '600',
                color: '{content.color}',
            },
            date: {
                hoverBackground: '{primary.color}',
                selectedBackground: '{primary.color}',
                rangeSelectedBackground: '{gray.200}',
                color: '#151E1C',
                hoverColor: '{content.color}',
                selectedColor: '{content.color}',
                rangeSelectedColor: '{content.color}',
                width: '41px',
                height: '41px',
                borderRadius: '0',
                padding: '0',
                focusRing: {
                    width: '{form.field.focus.ring.width}',
                    style: '{form.field.focus.ring.style}',
                    color: '{form.field.focus.ring.color}',
                    offset: '{form.field.focus.ring.offset}',
                    shadow: '{form.field.focus.ring.shadow}',
                },
            },
            monthView: {
                margin: '0.75rem 0 0 0',
            },
            month: {
                padding: '0.5rem',
                borderRadius: '0',
            },
            yearView: {
                margin: '0.75rem 0 0 0',
            },
            year: {
                padding: '0.5rem',
                borderRadius: '0',
            },
            buttonbar: {
                padding: '0.75rem 0 0 0',
                borderColor: '{content.border.color}',
            },
            timePicker: {
                padding: '0.75rem 0 0 0',
                borderColor: '{content.border.color}',
                gap: '0.5rem',
                buttonGap: '0.25rem',
            },
            colorScheme: {
                light: {
                    dropdown: {
                        background: '{surface.50}',
                        hoverBackground: '{surface.100}',
                        activeBackground: '{surface.200}',
                        color: '{surface.600}',
                        hoverColor: '{surface.700}',
                        activeColor: '{surface.800}',
                    },
                    today: {
                        background: '#fff',
                        color: '{content.color}',
                    },
                },
                dark: {
                    dropdown: {
                        background: '{surface.50}',
                        hoverBackground: '{surface.100}',
                        activeBackground: '{surface.200}',
                        color: '{surface.600}',
                        hoverColor: '{surface.700}',
                        activeColor: '{surface.800}',
                    },
                    today: {
                        background: '{surface.200}',
                        color: '{surface.900}',
                    },
                },
            },
        },
        card: {
            root: {
                background: '{content.background}',
                borderRadius: '{border.radius.lg}',
                color: '{content.color}',
                shadow: '0 .125rem .25rem rgba(0,0,0,.075)',
            },
            body: {
                padding: '1.5rem',
                gap: '0.75rem',
            },
            caption: {
                gap: '0.5rem',
            },
            title: {
                fontSize: '1.25rem',
                fontWeight: '700',
            },
            subtitle: {
                color: '{text.muted.color}',
            },
        },
        carousel: {
            root: {
                transitionDuration: '{transition.duration}',
            },
            content: {
                gap: '0.25rem',
            },
            indicatorList: {
                padding: '1rem',
                gap: '0.5rem',
            },
            indicator: {
                width: '1rem',
                height: '1rem',
                borderRadius: '50',
                focusRing: {
                    width: '{focus.ring.width}',
                    style: '{focus.ring.style}',
                    color: '{focus.ring.color}',
                    offset: '{focus.ring.offset}',
                    shadow: '{focus.ring.shadow}',
                },
            },
            colorScheme: {
                light: {
                    indicator: {
                        background: '{surface.200}',
                        hoverBackground: '{surface.300}',
                        activeBackground: '{primary.color}',
                    },
                },
                dark: {
                    indicator: {
                        background: '{surface.200}',
                        hoverBackground: '{surface.300}',
                        activeBackground: '{primary.color}',
                    },
                },
            },
        },
        cascadeselect: {
            root: {
                background: '{form.field.background}',
                disabledBackground: '{form.field.disabled.background}',
                filledBackground: '{form.field.filled.background}',
                filledHoverBackground: '{form.field.filled.hover.background}',
                filledFocusBackground: '{form.field.filled.focus.background}',
                borderColor: '{form.field.border.color}',
                hoverBorderColor: '{form.field.hover.border.color}',
                focusBorderColor: '{form.field.focus.border.color}',
                invalidBorderColor: '{form.field.invalid.border.color}',
                color: '{form.field.color}',
                disabledColor: '{form.field.disabled.color}',
                placeholderColor: '{form.field.placeholder.color}',
                invalidPlaceholderColor: '{form.field.invalid.placeholder.color}',
                shadow: '{form.field.shadow}',
                paddingX: '{form.field.padding.x}',
                paddingY: '{form.field.padding.y}',
                borderRadius: '{form.field.border.radius}',
                focusRing: {
                    width: '{form.field.focus.ring.width}',
                    style: '{form.field.focus.ring.style}',
                    color: '{form.field.focus.ring.color}',
                    offset: '{form.field.focus.ring.offset}',
                    shadow: '{form.field.focus.ring.shadow}',
                },
                transitionDuration: '{form.field.transition.duration}',
                sm: {
                    fontSize: '{form.field.sm.font.size}',
                    paddingX: '{form.field.sm.padding.x}',
                    paddingY: '{form.field.sm.padding.y}',
                },
                lg: {
                    fontSize: '{form.field.lg.font.size}',
                    paddingX: '{form.field.lg.padding.x}',
                    paddingY: '{form.field.lg.padding.y}',
                },
            },
            dropdown: {
                width: '2.5rem',
                color: '{form.field.icon.color}',
            },
            overlay: {
                background: '{overlay.select.background}',
                borderColor: '{overlay.select.border.color}',
                borderRadius: '{overlay.select.border.radius}',
                color: '{overlay.select.color}',
                shadow: '{overlay.select.shadow}',
            },
            list: {
                padding: '{list.padding}',
                gap: '{list.gap}',
                mobileIndent: '1.25rem',
            },
            option: {
                focusBackground: '{list.option.focus.background}',
                selectedBackground: '{list.option.selected.background}',
                selectedFocusBackground: '{list.option.selected.focus.background}',
                color: '{list.option.color}',
                focusColor: '{list.option.focus.color}',
                selectedColor: '{list.option.selected.color}',
                selectedFocusColor: '{list.option.selected.focus.color}',
                padding: '{list.option.padding}',
                borderRadius: '{list.option.border.radius}',
                icon: {
                    color: '{list.option.icon.color}',
                    focusColor: '{list.option.icon.focus.color}',
                    size: '0.875rem',
                },
            },
            clearIcon: {
                color: '{form.field.icon.color}',
            },
        },
        checkbox: {
            root: {
                borderRadius: '{border.radius.sm}',
                width: '24px',
                height: '24px',
                background: '{form.field.background}',
                checkedBackground: '{primary.color}',
                checkedHoverBackground: '{primary.hover.color}',
                disabledBackground: '{form.field.disabled.background}',
                filledBackground: '{form.field.filled.background}',
                borderColor: '{form.field.border.color}',
                hoverBorderColor: '{form.field.hover.border.color}',
                focusBorderColor: '{form.field.focus.border.color}',
                checkedBorderColor: '{primary.color}',
                checkedHoverBorderColor: '{primary.hover.color}',
                checkedFocusBorderColor: '{primary.color}',
                checkedDisabledBorderColor: '{form.field.border.color}',
                invalidBorderColor: '{form.field.invalid.border.color}',
                shadow: '{form.field.shadow}',
                focusRing: {
                    width: '{form.field.focus.ring.width}',
                    style: '{form.field.focus.ring.style}',
                    color: '{form.field.focus.ring.color}',
                    offset: '{form.field.focus.ring.offset}',
                    shadow: '{form.field.focus.ring.shadow}',
                },
                transitionDuration: '{form.field.transition.duration}',
                sm: {
                    width: '1.25rem',
                    height: '1.25rem',
                },
                lg: {
                    width: '1.75rem',
                    height: '1.75rem',
                },
            },
            icon: {
                size: '1rem',
                color: '{form.field.color}',
                checkedColor: '#151e1c',
                checkedHoverColor: '#151e1c',
                disabledColor: '{form.field.disabled.color}',
                sm: {
                    size: '0.75rem',
                },
                lg: {
                    size: '1.25rem',
                },
            },
        },
        chip: {
            root: {
                borderRadius: '16px',
                paddingX: '0.875rem',
                paddingY: '0.625rem',
                gap: '0.5rem',
                transitionDuration: '{transition.duration}',
            },
            image: {
                width: '2rem',
                height: '2rem',
            },
            icon: {
                size: '1rem',
            },
            removeIcon: {
                size: '1rem',
                focusRing: {
                    width: '{focus.ring.width}',
                    style: '{focus.ring.style}',
                    color: '{focus.ring.color}',
                    offset: '{focus.ring.offset}',
                    shadow: '{focus.ring.shadow}',
                },
            },
            colorScheme: {
                light: {
                    root: {
                        background: '{surface.100}',
                        color: '{surface.800}',
                    },
                    icon: {
                        color: '{surface.800}',
                    },
                    removeIcon: {
                        color: '{surface.800}',
                    },
                },
                dark: {
                    root: {
                        background: '{surface.100}',
                        color: '{surface.800}',
                    },
                    icon: {
                        color: '{surface.800}',
                    },
                    removeIcon: {
                        color: '{surface.800}',
                    },
                },
            },
        },
        colorpicker: {
            root: {
                transitionDuration: '{transition.duration}',
            },
            preview: {
                width: '1.75rem',
                height: '1.75rem',
                borderRadius: '{form.field.border.radius}',
                focusRing: {
                    width: '{form.field.focus.ring.width}',
                    style: '{form.field.focus.ring.style}',
                    color: '{form.field.focus.ring.color}',
                    offset: '{form.field.focus.ring.offset}',
                    shadow: '{form.field.focus.ring.shadow}',
                },
            },
            panel: {
                shadow: '{overlay.popover.shadow}',
                borderRadius: '{overlay.popover.borderRadius}',
            },
            colorScheme: {
                light: {
                    panel: {
                        background: '{surface.800}',
                        borderColor: '{surface.900}',
                    },
                    handle: {
                        color: '{surface.0}',
                    },
                },
                dark: {
                    panel: {
                        background: '{surface.800}',
                        borderColor: '{surface.900}',
                    },
                    handle: {
                        color: '{surface.0}',
                    },
                },
            },
        },
        confirmdialog: {
            icon: {
                size: '17px',
                color: '{overlay.modal.color}',
            },
            content: {
                gap: '1rem',
            },
        },
        confirmpopup: {
            root: {
                background: '{overlay.popover.background}',
                borderColor: '{overlay.popover.border.color}',
                color: '{overlay.popover.color}',
                borderRadius: '{overlay.popover.border.radius}',
                shadow: '{overlay.popover.shadow}',
                gutter: '10px',
                arrowOffset: '1.25rem',
            },
            content: {
                padding: '{overlay.popover.padding}',
                gap: '1rem',
            },
            icon: {
                size: '1.5rem',
                color: '{overlay.popover.color}',
            },
            footer: {
                gap: '0.5rem',
                padding: '0 {overlay.popover.padding} {overlay.popover.padding} {overlay.popover.padding}',
            },
        },
        contextmenu: {
            root: {
                background: '{content.background}',
                borderColor: '{content.border.color}',
                color: '{content.color}',
                borderRadius: '{content.border.radius}',
                shadow: '{overlay.navigation.shadow}',
                transitionDuration: '{transition.duration}',
            },
            list: {
                padding: '{navigation.list.padding}',
                gap: '{navigation.list.gap}',
            },
            item: {
                focusBackground: '{navigation.item.focus.background}',
                activeBackground: '{navigation.item.active.background}',
                color: '{navigation.item.color}',
                focusColor: '{navigation.item.focus.color}',
                activeColor: '{navigation.item.active.color}',
                padding: '{navigation.item.padding}',
                borderRadius: '{navigation.item.border.radius}',
                gap: '{navigation.item.gap}',
                icon: {
                    color: '{navigation.item.icon.color}',
                    focusColor: '{navigation.item.icon.focus.color}',
                    activeColor: '{navigation.item.icon.active.color}',
                },
            },
            submenu: {
                mobileIndent: '1.25rem',
            },
            submenuIcon: {
                size: '{navigation.submenu.icon.size}',
                color: '{navigation.submenu.icon.color}',
                focusColor: '{navigation.submenu.icon.focus.color}',
                activeColor: '{navigation.submenu.icon.active.color}',
            },
            separator: {
                borderColor: '{content.border.color}',
            },
        },
        dataview: {
            root: {
                borderColor: '{content.border.color}',
                borderWidth: '1px',
                borderRadius: '4px',
                padding: '0',
            },
            header: {
                borderColor: '{content.border.color}',
                borderWidth: '0 0 1px 0',
                padding: '0.875rem 1.125rem',
                borderRadius: '5px 5px 0 0',
            },
            content: {
                background: '{content.background}',
                color: '{content.color}',
                borderColor: 'transparent',
                borderWidth: '0',
                padding: '0',
                borderRadius: '5px',
            },
            footer: {
                background: '{content.background}',
                color: '{content.color}',
                borderColor: '{content.border.color}',
                borderWidth: '1px 0 0 0',
                padding: '0.875rem 1.125rem',
                borderRadius: '0 0 5px 5px',
            },
            paginatorTop: {
                borderColor: '{content.border.color}',
                borderWidth: '0 0 1px 0',
            },
            paginatorBottom: {
                borderColor: '{content.border.color}',
                borderWidth: '1px 0 0 0',
            },
            colorScheme: {
                light: {
                    header: {
                        background: '{surface.50}',
                        color: '{text.color}',
                    },
                },
                dark: {
                    header: {
                        background: '{surface.50}',
                        color: '{text.color}',
                    },
                },
            },
        },
        datatable: {
            root: {
                transitionDuration: '{transition.duration}',
            },
            header: {
                borderColor: '#D9DEDD',
                borderWidth: '1px 0 1px 0',
                padding: '12px 12px',
            },
            headerCell: {
                selectedBackground: '#fff',
                borderColor: '#D9DEDD',
                hoverColor: '#151E1C',
                selectedColor: '#151E1C',
                gap: '0.5rem',
                padding: '12px 12px',
                focusRing: {
                    width: '{focus.ring.width}',
                    style: '{focus.ring.style}',
                    color: '{focus.ring.color}',
                    offset: '{focus.ring.offset}',
                    shadow: 'inset {focus.ring.shadow}',
                },
            },
            columnTitle: {
                fontWeight: '500',
            },
            row: {
                background: 'transparent',
                hoverBackground: 'transparent',
                selectedBackground: '#f5f5f5',
                color: '{content.color}',
                hoverColor: '{content.hover.color}',
                selectedColor: '{highlight.color}',
                focusRing: {
                    width: '{focus.ring.width}',
                    style: '{focus.ring.style}',
                    color: '{focus.ring.color}',
                    offset: '{focus.ring.offset}',
                    shadow: 'inset {focus.ring.shadow}',
                },
            },
            bodyCell: {
                borderColor: '#D9DEDD',
                padding: '20px 12px',
            },
            footerCell: {
                borderColor: '#D9DEDD',
                padding: '12px 12px',
            },
            columnFooter: {
                fontWeight: '700',
            },
            footer: {
                borderColor: '{datatable.border.color}',
                borderWidth: '0 0 1px 0',
                padding: '16px 12px',
            },
            dropPoint: {
                color: '{primary.color}',
            },
            resizeIndicator: {
                width: '1px',
                color: '{primary.color}',
            },
            sortIcon: {
                color: '{text.muted.color}',
                hoverColor: '{text.hover.muted.color}',
                size: '10px',
            },
            loadingIcon: {
                size: '2rem',
            },
            rowToggleButton: {
                hoverBackground: '{content.hover.background}',
                selectedHoverBackground: '{content.background}',
                color: '{text.muted.color}',
                hoverColor: '{text.color}',
                selectedHoverColor: '{primary.color}',
                size: '1.75rem',
                borderRadius: '50%',
                focusRing: {
                    width: '{focus.ring.width}',
                    style: '{focus.ring.style}',
                    color: '{focus.ring.color}',
                    offset: '{focus.ring.offset}',
                    shadow: '{focus.ring.shadow}',
                },
            },
            filter: {
                inlineGap: '0.5rem',
                overlaySelect: {
                    background: '{overlay.select.background}',
                    borderColor: '{overlay.select.border.color}',
                    borderRadius: '{overlay.select.border.radius}',
                    color: '{overlay.select.color}',
                    shadow: '{overlay.select.shadow}',
                },
                overlayPopover: {
                    background: '{overlay.popover.background}',
                    borderColor: '{overlay.popover.border.color}',
                    borderRadius: '{overlay.popover.border.radius}',
                    color: '{overlay.popover.color}',
                    shadow: '{overlay.popover.shadow}',
                    padding: '{overlay.popover.padding}',
                    gap: '0.5rem',
                },
                rule: {
                    borderColor: '{content.border.color}',
                },
                constraintList: {
                    padding: '{list.padding}',
                    gap: '{list.gap}',
                },
                constraint: {
                    focusBackground: '{list.option.focus.background}',
                    selectedBackground: '{list.option.selected.background}',
                    selectedFocusBackground: '{list.option.selected.focus.background}',
                    color: '{list.option.color}',
                    focusColor: '{list.option.focus.color}',
                    selectedColor: '{list.option.selected.color}',
                    selectedFocusColor: '{list.option.selected.focus.color}',
                    separator: {
                        borderColor: '{content.border.color}',
                    },
                    padding: '{list.option.padding}',
                    borderRadius: '{list.option.border.radius}',
                },
            },
            paginatorTop: {
                borderColor: '{datatable.border.color}',
                borderWidth: '0 0 1px 0',
            },
            paginatorBottom: {
                borderColor: '{datatable.border.color}',
                borderWidth: '0 0 1px 0',
            },
            colorScheme: {
                light: {
                    root: {
                        borderColor: '#D9DEDD',
                    },
                    header: {
                        background: '#fff',
                        color: '#151E1C',
                    },
                    headerCell: {
                        background: '#fff',
                        hoverBackground: '#f5f5f5',
                        color: '#151E1C',
                    },
                    footer: {
                        background: '{surface.50}',
                        color: '#151E1C',
                    },
                    footerCell: {
                        background: '{surface.50}',
                        color: '#151E1C',
                    },
                    row: {
                        stripedBackground: '#f5f5f5',
                    },
                    bodyCell: {
                        selectedBorderColor: '#D9DEDD',
                    },
                },
                dark: {
                    root: {
                        borderColor: '#e9e9e9',
                    },
                    header: {
                        background: 'transparent',
                        color: '{stone.500}',
                    },
                    headerCell: {
                        background: 'transparent',
                        hoverBackground: '{slate.200}',
                        color: '{stone.500}',
                    },
                    footer: {
                        background: '{surface.50}',
                        color: '{text.color}',
                    },
                    footerCell: {
                        background: '{surface.50}',
                        color: '{text.color}',
                    },
                    row: {
                        stripedBackground: '{surface.100}',
                    },
                    bodyCell: {
                        selectedBorderColor: '{primary.100}',
                    },
                },
            },
        },
        dialog: {
            root: {
                background: '{overlay.modal.background}',
                borderColor: '{overlay.modal.border.color}',
                color: '{overlay.modal.color}',
                borderRadius: '{overlay.modal.border.radius}',
                shadow: '{overlay.modal.shadow}',
            },
            header: {
                padding: '24px',
                gap: '0.5rem',
            },
            title: {
                fontSize: '30px',
                fontWeight: '500',
            },
            content: {
                padding: '32px',
            },
            footer: {
                padding: '1rem 1.5rem',
                gap: '0.5rem',
            },
        },
        divider: {
            root: {
                borderColor: '{content.border.color}',
            },
            content: {
                background: '{content.background}',
                color: '{text.color}',
            },
            horizontal: {
                margin: '1.125rem 0',
                padding: '0 1.125rem',
                content: {
                    padding: '0 0.625rem',
                },
            },
            vertical: {
                margin: '0 1.125rem',
                padding: '1.125rem 0',
                content: {
                    padding: '0.625rem 0',
                },
            },
        },
        dock: {
            root: {
                background: 'rgba(255, 255, 255, 0.1)',
                borderColor: 'rgba(255, 255, 255, 0.2)',
                padding: '0.5rem',
                borderRadius: '{border.radius.lg}',
            },
            item: {
                borderRadius: '{content.border.radius}',
                padding: '0.5rem',
                size: '3rem',
                focusRing: {
                    width: '{focus.ring.width}',
                    style: '{focus.ring.style}',
                    color: '{focus.ring.color}',
                    offset: '{focus.ring.offset}',
                    shadow: '{focus.ring.shadow}',
                },
            },
        },
        drawer: {
            root: {
                background: '{neutral.50}',
                borderColor: '{overlay.modal.border.color}',
                color: '{overlay.modal.color}',
                shadow: '{overlay.modal.shadow}',
            },
            header: {
                padding: '{overlay.modal.padding}',
            },
            title: {
                fontSize: '1.5rem',
                fontWeight: '600',
            },
            content: {
                padding: '0 {overlay.modal.padding} {overlay.modal.padding} {overlay.modal.padding}',
            },
            footer: {
                padding: '{overlay.modal.padding}',
            },
        },
        editor: {
            toolbar: {
                borderColor: '{content.border.color}',
                borderRadius: '{content.border.radius}',
            },
            toolbarItem: {
                color: '{text.muted.color}',
                hoverColor: '{text.color}',
                activeColor: '{primary.color}',
            },
            overlay: {
                background: '{overlay.select.background}',
                borderColor: '{overlay.select.border.color}',
                borderRadius: '{overlay.select.border.radius}',
                color: '{overlay.select.color}',
                shadow: '{overlay.select.shadow}',
                padding: '{list.padding}',
            },
            overlayOption: {
                focusBackground: '{list.option.focus.background}',
                color: '{list.option.color}',
                focusColor: '{list.option.focus.color}',
                padding: '{list.option.padding}',
                borderRadius: '{list.option.border.radius}',
            },
            content: {
                background: '{content.background}',
                borderColor: '{content.border.color}',
                color: '{content.color}',
                borderRadius: '{content.border.radius}',
            },
            colorScheme: {
                light: {
                    toolbar: {
                        background: '{surface.50}',
                    },
                },
                dark: {
                    toolbar: {
                        background: '{surface.50}',
                    },
                },
            },
        },
        fieldset: {
            root: {
                background: '{content.background}',
                borderColor: '{content.border.color}',
                borderRadius: '{content.border.radius}',
                color: '{content.color}',
                padding: '0.75rem 1.125rem 1.125rem 1.125rem',
                transitionDuration: '{transition.duration}',
            },
            legend: {
                borderRadius: '{content.border.radius}',
                borderWidth: '1px',
                borderColor: '{content.border.color}',
                padding: '0.625rem 0.875rem',
                gap: '0.5rem',
                fontWeight: '700',
                focusRing: {
                    width: '{focus.ring.width}',
                    style: '{focus.ring.style}',
                    color: '{focus.ring.color}',
                    offset: '{focus.ring.offset}',
                    shadow: '{focus.ring.shadow}',
                },
            },
            toggleIcon: {
                color: '{text.muted.color}',
                hoverColor: '{text.hover.muted.color}',
            },
            content: {
                padding: '0',
            },
            colorScheme: {
                light: {
                    legend: {
                        background: '{surface.50}',
                        hoverBackground: '{surface.100}',
                        color: '{text.color}',
                        hoverColor: '{text.hover.color}',
                    },
                },
                dark: {
                    legend: {
                        background: '{surface.50}',
                        hoverBackground: '{surface.100}',
                        color: '{text.color}',
                        hoverColor: '{text.hover.color}',
                    },
                },
            },
        },
        fileupload: {
            root: {
                background: 'none',
                borderColor: '{content.border.color}',
                color: '{content.color}',
                borderRadius: '{content.border.radius}',
                transitionDuration: '{transition.duration}',
            },
            header: {
                borderWidth: '0 0 1px 0',
                borderColor: '{content.border.color}',
                padding: '1.125rem',
                borderRadius: '5px 5px 0 0',
                gap: '0.5rem',
            },
            content: {
                highlightBorderColor: '{primary.color}',
                padding: '1.125rem',
                gap: '1rem',
            },
            file: {
                padding: '1rem',
                gap: '1rem',
                borderColor: '{content.border.color}',
                info: {
                    gap: '0.5rem',
                },
            },
            fileList: {
                gap: '0.5rem',
            },
            progressbar: {
                height: '0.25rem',
            },
            basic: {
                gap: '0.5rem',
            },
            colorScheme: {
                light: {
                    header: {
                        background: '{surface.50}',
                        color: '{text.color}',
                    },
                },
                dark: {
                    header: {
                        background: '{surface.50}',
                        color: '{text.color}',
                    },
                },
            },
        },
        iftalabel: {
            root: {
                color: '{form.field.float.label.color}',
                focusColor: '{form.field.float.label.focus.color}',
                invalidColor: '{form.field.float.label.invalid.color}',
                transitionDuration: '0.2s',
                positionX: '{form.field.padding.x}',
                top: '{form.field.padding.y}',
                fontSize: '0.75rem',
                fontWeight: '400',
            },
            input: {
                paddingTop: '1.875rem',
                paddingBottom: '{form.field.padding.y}',
            },
        },
        floatlabel: {
            root: {
                color: '{form.field.float.label.color}',
                focusColor: '{form.field.float.label.focus.color}',
                activeColor: '{form.field.float.label.active.color}',
                invalidColor: '{form.field.float.label.invalid.color}',
                transitionDuration: '0.2s',
                positionX: '{form.field.padding.x}',
                positionY: '{form.field.padding.y}',
                fontWeight: '500',
                active: {
                    fontSize: '0.75rem',
                    fontWeight: '400',
                },
            },
            over: {
                active: {
                    top: '-1.375rem',
                },
            },
            in: {
                input: {
                    paddingTop: '1.875rem',
                    paddingBottom: '{form.field.padding.y}',
                },
                active: {
                    top: '{form.field.padding.y}',
                },
            },
            on: {
                borderRadius: '{border.radius.xs}',
                active: {
                    background: '{form.field.background}',
                    padding: '0 0.125rem',
                },
            },
        },
        galleria: {
            root: {
                borderWidth: '1px',
                borderColor: '{content.border.color}',
                borderRadius: '{content.border.radius}',
                transitionDuration: '{transition.duration}',
            },
            navButton: {
                background: 'rgba(255, 255, 255, 0.1)',
                hoverBackground: 'rgba(255, 255, 255, 0.2)',
                color: '{surface.100}',
                hoverColor: '{surface.0}',
                size: '3rem',
                gutter: '0',
                prev: {
                    borderRadius: '0 12px 12px 0',
                },
                next: {
                    borderRadius: '12px 0 0 12px',
                },
                focusRing: {
                    width: '{focus.ring.width}',
                    style: '{focus.ring.style}',
                    color: '{focus.ring.color}',
                    offset: '{focus.ring.offset}',
                    shadow: '{focus.ring.shadow}',
                },
            },
            navIcon: {
                size: '1.5rem',
            },
            thumbnailsContent: {
                padding: '1rem 0.25rem',
            },
            thumbnailNavButton: {
                size: '2rem',
                borderRadius: '{content.border.radius}',
                gutter: '0.5rem',
                focusRing: {
                    width: '{focus.ring.width}',
                    style: '{focus.ring.style}',
                    color: '{focus.ring.color}',
                    offset: '{focus.ring.offset}',
                    shadow: '{focus.ring.shadow}',
                },
            },
            thumbnailNavButtonIcon: {
                size: '1rem',
            },
            caption: {
                background: 'rgba(0, 0, 0, 0.5)',
                color: '{surface.100}',
                padding: '1rem',
            },
            indicatorList: {
                gap: '0.5rem',
                padding: '1rem',
            },
            indicatorButton: {
                width: '1rem',
                height: '1rem',
                activeBackground: '{primary.color}',
                borderRadius: '50%',
                focusRing: {
                    width: '{focus.ring.width}',
                    style: '{focus.ring.style}',
                    color: '{focus.ring.color}',
                    offset: '{focus.ring.offset}',
                    shadow: '{focus.ring.shadow}',
                },
            },
            insetIndicatorList: {
                background: 'rgba(0, 0, 0, 0.5)',
            },
            insetIndicatorButton: {
                background: 'rgba(255, 255, 255, 0.4)',
                hoverBackground: 'rgba(255, 255, 255, 0.6)',
                activeBackground: 'rgba(255, 255, 255, 0.9)',
            },
            closeButton: {
                size: '3rem',
                gutter: '0.5rem',
                background: '#2e324a',
                hoverBackground: '#404873',
                color: '{surface.50}',
                hoverColor: '{surface.0}',
                borderRadius: '50%',
                focusRing: {
                    width: '{focus.ring.width}',
                    style: '{focus.ring.style}',
                    color: '{focus.ring.color}',
                    offset: '{focus.ring.offset}',
                    shadow: '{focus.ring.shadow}',
                },
            },
            closeButtonIcon: {
                size: '1.5rem',
            },
            colorScheme: {
                light: {
                    thumbnailsContent: {
                        background: '{surface.50}',
                    },
                    thumbnailNavButton: {
                        hoverBackground: '{surface.100}',
                        color: '{surface.600}',
                        hoverColor: '{surface.700}',
                    },
                    indicatorButton: {
                        background: '{surface.200}',
                        hoverBackground: '{surface.300}',
                    },
                },
                dark: {
                    thumbnailsContent: {
                        background: '{surface.50}',
                    },
                    thumbnailNavButton: {
                        hoverBackground: '{surface.100}',
                        color: '{surface.600}',
                        hoverColor: '{surface.700}',
                    },
                    indicatorButton: {
                        background: '{surface.200}',
                        hoverBackground: '{surface.300}',
                    },
                },
            },
        },
        iconfield: {
            icon: {
                color: '{form.field.icon.color}',
            },
        },
        image: {
            root: {
                transitionDuration: '{transition.duration}',
            },
            preview: {
                icon: {
                    size: '1.5rem',
                },
                mask: {
                    background: '{mask.background}',
                    color: '{mask.color}',
                },
            },
            toolbar: {
                position: {
                    left: 'auto',
                    right: '1rem',
                    top: '1rem',
                    bottom: 'auto',
                },
                blur: '8px',
                background: 'rgba(255,255,255,0.1)',
                borderColor: 'rgba(255,255,255,0.2)',
                borderWidth: '1px',
                borderRadius: '{content.border.radius}',
                padding: '.5rem',
                gap: '0.5rem',
            },
            action: {
                hoverBackground: 'rgba(255,255,255,0.1)',
                color: '{surface.50}',
                hoverColor: '{surface.0}',
                size: '3rem',
                iconSize: '1.5rem',
                borderRadius: '{content.border.radius}',
                focusRing: {
                    width: '{focus.ring.width}',
                    style: '{focus.ring.style}',
                    color: '{focus.ring.color}',
                    offset: '{focus.ring.offset}',
                    shadow: '{focus.ring.shadow}',
                },
            },
        },
        imagecompare: {
            handle: {
                size: '15px',
                hoverSize: '30px',
                background: 'rgba(255,255,255,0.3)',
                hoverBackground: 'rgba(255,255,255,0.3)',
                borderColor: 'rgba(255,255,255,0.3)',
                hoverBorderColor: 'rgba(255,255,255,0.3)',
                borderWidth: '3px',
                borderRadius: '50%',
                transitionDuration: '{transition.duration}',
                focusRing: {
                    width: '{focus.ring.width}',
                    style: '{focus.ring.style}',
                    color: 'rgba(255,255,255,0.3)',
                    offset: '{focus.ring.offset}',
                    shadow: '{focus.ring.shadow}',
                },
            },
        },
        inlinemessage: {
            root: {
                padding: '{form.field.padding.y} {form.field.padding.x}',
                borderRadius: '{content.border.radius}',
                gap: '0.5rem',
            },
            text: {
                fontWeight: '500',
            },
            icon: {
                size: '1.125rem',
            },
            colorScheme: {
                light: {
                    info: {
                        background: 'color-mix(in srgb, {blue.50}, transparent 5%)',
                        borderColor: 'color-mix(in srgb, {blue.50}, transparent 5%)',
                        color: '{blue.600}',
                        shadow: 'none',
                    },
                    success: {
                        background: 'color-mix(in srgb, {green.50}, transparent 5%)',
                        borderColor: 'color-mix(in srgb, {green.50}, transparent 5%)',
                        color: '{green.600}',
                        shadow: 'none',
                    },
                    warn: {
                        background: 'color-mix(in srgb,{yellow.50}, transparent 5%)',
                        borderColor: 'color-mix(in srgb,{yellow.50}, transparent 5%)',
                        color: '{yellow.600}',
                        shadow: 'none',
                    },
                    error: {
                        background: 'color-mix(in srgb, {red.50}, transparent 5%)',
                        borderColor: 'color-mix(in srgb, {red.50}, transparent 5%)',
                        color: '{red.600}',
                        shadow: 'none',
                    },
                    secondary: {
                        background: '{surface.100}',
                        borderColor: '{surface.100}',
                        color: '{surface.600}',
                        shadow: 'none',
                    },
                    contrast: {
                        background: '{surface.900}',
                        borderColor: '{surface.900}',
                        color: '{surface.50}',
                        shadow: 'none',
                    },
                },
                dark: {
                    info: {
                        background: 'color-mix(in srgb, {blue.50}, transparent 5%)',
                        borderColor: 'color-mix(in srgb, {blue.50}, transparent 5%)',
                        color: '{blue.600}',
                        shadow: 'none',
                    },
                    success: {
                        background: 'color-mix(in srgb, {green.50}, transparent 5%)',
                        borderColor: 'color-mix(in srgb, {green.50}, transparent 5%)',
                        color: '{green.600}',
                        shadow: 'none',
                    },
                    warn: {
                        background: 'color-mix(in srgb,{yellow.50}, transparent 5%)',
                        borderColor: 'color-mix(in srgb,{yellow.50}, transparent 5%)',
                        color: '{yellow.600}',
                        shadow: 'none',
                    },
                    error: {
                        background: 'color-mix(in srgb, {red.50}, transparent 5%)',
                        borderColor: 'color-mix(in srgb, {red.50}, transparent 5%)',
                        color: '{red.600}',
                        shadow: 'none',
                    },
                    secondary: {
                        background: '{surface.100}',
                        borderColor: '{surface.100}',
                        color: '{surface.600}',
                        shadow: 'none',
                    },
                    contrast: {
                        background: '{surface.900}',
                        borderColor: '{surface.900}',
                        color: '{surface.50}',
                        shadow: 'none',
                    },
                },
            },
        },
        inplace: {
            root: {
                padding: '{form.field.padding.y} {form.field.padding.x}',
                borderRadius: '{content.border.radius}',
                focusRing: {
                    width: '{focus.ring.width}',
                    style: '{focus.ring.style}',
                    color: '{focus.ring.color}',
                    offset: '{focus.ring.offset}',
                    shadow: '{focus.ring.shadow}',
                },
                transitionDuration: '{transition.duration}',
            },
            display: {
                hoverBackground: '{content.hover.background}',
                hoverColor: '{content.hover.color}',
            },
        },
        inputchips: {
            root: {
                background: '{form.field.background}',
                disabledBackground: '{form.field.disabled.background}',
                filledBackground: '{form.field.filled.background}',
                filledFocusBackground: '{form.field.filled.focus.background}',
                borderColor: '{form.field.border.color}',
                hoverBorderColor: '{form.field.hover.border.color}',
                focusBorderColor: '{form.field.focus.border.color}',
                invalidBorderColor: '{form.field.invalid.border.color}',
                color: '{form.field.color}',
                disabledColor: '{form.field.disabled.color}',
                placeholderColor: '{form.field.placeholder.color}',
                shadow: '{form.field.shadow}',
                paddingX: '{form.field.padding.x}',
                paddingY: '{form.field.padding.y}',
                borderRadius: '{form.field.border.radius}',
                focusRing: {
                    width: '{form.field.focus.ring.width}',
                    style: '{form.field.focus.ring.style}',
                    color: '{form.field.focus.ring.color}',
                    offset: '{form.field.focus.ring.offset}',
                    shadow: '{form.field.focus.ring.shadow}',
                },
                transitionDuration: '{form.field.transition.duration}',
            },
            chip: {
                borderRadius: '{border.radius.sm}',
            },
            colorScheme: {
                light: {
                    chip: {
                        focusBackground: '{surface.200}',
                        color: '{surface.800}',
                    },
                },
                dark: {
                    chip: {
                        focusBackground: '{surface.200}',
                        color: '{surface.800}',
                    },
                },
            },
        },
        inputgroup: {
            addon: {
                borderRadius: '{form.field.border.radius}',
                padding: '0.625rem 0.8rem',
                minWidth: '2.85rem',
            },
            colorScheme: {
                light: {
                    addon: {
                        background: '#F7F8F7',
                        borderColor: '{form.field.border.color}',
                        color: '{text.muted.color}',
                    },
                },
                dark: {
                    addon: {
                        background: '{surface.50}',
                        borderColor: '{form.field.border.color}',
                        color: '{text.muted.color}',
                    },
                },
            },
        },
        inputnumber: {
            root: {
                transitionDuration: '{transition.duration}',
            },
            button: {
                width: '2.5rem',
                borderRadius: '{form.field.border.radius}',
                verticalPadding: '{form.field.padding.y}',
            },
            colorScheme: {
                light: {
                    button: {
                        background: '{surface.100}',
                        hoverBackground: '{surface.200}',
                        activeBackground: '{surface.300}',
                        borderColor: '{form.field.border.color}',
                        hoverBorderColor: '{form.field.border.color}',
                        activeBorderColor: '{form.field.border.color}',
                        color: '{surface.600}',
                        hoverColor: '{surface.700}',
                        activeColor: '{surface.800}',
                    },
                },
                dark: {
                    button: {
                        background: '{surface.100}',
                        hoverBackground: '{surface.200}',
                        activeBackground: '{surface.300}',
                        borderColor: '{form.field.border.color}',
                        hoverBorderColor: '{form.field.border.color}',
                        activeBorderColor: '{form.field.border.color}',
                        color: '{surface.600}',
                        hoverColor: '{surface.700}',
                        activeColor: '{surface.800}',
                    },
                },
            },
        },
        inputotp: {
            root: {
                gap: '0.5rem',
            },
            input: {
                width: '2.5rem',
                sm: {
                    width: '2rem',
                },
                lg: {
                    width: '3rem',
                },
            },
        },
        inputtext: {
            root: {
                background: '{form.field.background}',
                disabledBackground: '{form.field.disabled.background}',
                filledBackground: '{form.field.filled.background}',
                filledHoverBackground: '{form.field.filled.hover.background}',
                filledFocusBackground: '{form.field.filled.focus.background}',
                borderColor: '{form.field.border.color}',
                hoverBorderColor: '{form.field.hover.border.color}',
                focusBorderColor: '{form.field.focus.border.color}',
                invalidBorderColor: '{form.field.invalid.border.color}',
                color: '{form.field.color}',
                disabledColor: '{form.field.color}',
                placeholderColor: '{form.field.placeholder.color}',
                invalidPlaceholderColor: '{form.field.invalid.placeholder.color}',
                shadow: '{form.field.shadow}',
                paddingX: '{form.field.padding.x}',
                paddingY: '{form.field.padding.y}',
                borderRadius: '{form.field.border.radius}',
                focusRing: {
                    width: '{form.field.focus.ring.width}',
                    style: '{form.field.focus.ring.style}',
                    color: '{form.field.focus.ring.color}',
                    offset: '{form.field.focus.ring.offset}',
                    shadow: '{form.field.focus.ring.shadow}',
                },
                transitionDuration: '{form.field.transition.duration}',
                sm: {
                    fontSize: '{form.field.sm.font.size}',
                    paddingX: '{form.field.sm.padding.x}',
                    paddingY: '{form.field.sm.padding.y}',
                },
                lg: {
                    fontSize: '{form.field.lg.font.size}',
                    paddingX: '{form.field.lg.padding.x}',
                    paddingY: '{form.field.lg.padding.y}',
                },
            },
        },
        knob: {
            root: {
                transitionDuration: '{transition.duration}',
                focusRing: {
                    width: '{focus.ring.width}',
                    style: '{focus.ring.style}',
                    color: '{focus.ring.color}',
                    offset: '{focus.ring.offset}',
                    shadow: '{focus.ring.shadow}',
                },
            },
            value: {
                background: '{primary.color}',
            },
            range: {
                background: '{content.border.color}',
            },
            text: {
                color: '{text.muted.color}',
            },
        },
        listbox: {
            root: {
                background: '{form.field.background}',
                disabledBackground: '{form.field.disabled.background}',
                borderColor: '{form.field.border.color}',
                invalidBorderColor: '{form.field.invalid.border.color}',
                color: '{form.field.color}',
                disabledColor: '{form.field.disabled.color}',
                shadow: '{form.field.shadow}',
                borderRadius: '{form.field.border.radius}',
                transitionDuration: '{form.field.transition.duration}',
            },
            list: {
                padding: '{list.padding}',
                gap: '{list.gap}',
                header: {
                    padding: '{list.header.padding}',
                },
            },
            option: {
                focusBackground: '#fff',
                selectedBackground: '#fff',
                selectedFocusBackground: '#fff',
                color: '{list.option.color}',
                focusColor: '#ff6626',
                selectedColor: '{list.option.selected.color}',
                selectedFocusColor: '#ff6626',
                padding: '8px 0',
                borderRadius: '{list.option.border.radius}',
            },
            optionGroup: {
                background: '{list.option.group.background}',
                color: '{list.option.group.color}',
                fontWeight: '{list.option.group.font.weight}',
                padding: '{list.option.group.padding}',
            },
            checkmark: {
                color: '{list.option.color}',
                gutterStart: '-0.5rem',
                gutterEnd: '0.5rem',
            },
            emptyMessage: {
                padding: '{list.option.padding}',
            },
            colorScheme: {
                light: {
                    option: {
                        stripedBackground: '{surface.50}',
                    },
                },
                dark: {
                    option: {
                        stripedBackground: '{surface.50}',
                    },
                },
            },
        },
        megamenu: {
            root: {
                borderColor: 'transparent',
                borderRadius: '{content.border.radius}',
                color: '{content.color}',
                gap: '0.5rem',
                verticalOrientation: {
                    padding: '{navigation.list.padding}',
                    gap: '{navigation.list.gap}',
                },
                horizontalOrientation: {
                    padding: '0.75rem 1rem',
                    gap: '0.5rem',
                },
                transitionDuration: '{transition.duration}',
            },
            baseItem: {
                borderRadius: '{content.border.radius}',
                padding: '0.75rem 1rem',
            },
            item: {
                focusBackground: '{navigation.item.focus.background}',
                activeBackground: '{navigation.item.active.background}',
                color: '{navigation.item.color}',
                focusColor: '{navigation.item.focus.color}',
                activeColor: '{navigation.item.active.color}',
                padding: '{navigation.item.padding}',
                borderRadius: '{navigation.item.border.radius}',
                gap: '{navigation.item.gap}',
                icon: {
                    color: '{navigation.item.icon.color}',
                    focusColor: '{navigation.item.icon.focus.color}',
                    activeColor: '{navigation.item.icon.active.color}',
                },
            },
            overlay: {
                padding: '0',
                background: '{content.background}',
                borderColor: '{content.border.color}',
                borderRadius: '{content.border.radius}',
                color: '{content.color}',
                shadow: '{overlay.navigation.shadow}',
                gap: '0.5rem',
            },
            submenu: {
                padding: '{navigation.list.padding}',
                gap: '{navigation.list.gap}',
            },
            submenuLabel: {
                padding: '{navigation.submenu.label.padding}',
                fontWeight: '{navigation.submenu.label.font.weight}',
                background: '{navigation.submenu.label.background.}',
                color: '{navigation.submenu.label.color}',
            },
            submenuIcon: {
                size: '{navigation.submenu.icon.size}',
                color: '{navigation.submenu.icon.color}',
                focusColor: '{navigation.submenu.icon.focus.color}',
                activeColor: '{navigation.submenu.icon.active.color}',
            },
            separator: {
                borderColor: '{content.border.color}',
            },
            mobileButton: {
                borderRadius: '50%',
                size: '2rem',
                color: '{text.muted.color}',
                hoverColor: '{text.hover.muted.color}',
                hoverBackground: '{content.hover.background}',
                focusRing: {
                    width: '{focus.ring.width}',
                    style: '{focus.ring.style}',
                    color: '{focus.ring.color}',
                    offset: '{focus.ring.offset}',
                    shadow: '{focus.ring.shadow}',
                },
            },
            colorScheme: {
                light: {
                    root: {
                        background: '{surface.50}',
                    },
                },
                dark: {
                    root: {
                        background: '{surface.50}',
                    },
                },
            },
        },
        menu: {
            root: {
                background: '{content.background}',
                borderColor: '{content.border.color}',
                color: '{content.color}',
                borderRadius: '{content.border.radius}',
                shadow: '{overlay.navigation.shadow}',
                transitionDuration: '{transition.duration}',
            },
            list: {
                padding: '{navigation.list.padding}',
                gap: '{navigation.list.gap}',
            },
            item: {
                focusBackground: '{navigation.item.focus.background}',
                color: '{navigation.item.color}',
                focusColor: '{navigation.item.focus.color}',
                padding: '{navigation.item.padding}',
                borderRadius: '{navigation.item.border.radius}',
                gap: '{navigation.item.gap}',
                icon: {
                    color: '{navigation.item.icon.color}',
                    focusColor: '{navigation.item.icon.focus.color}',
                },
            },
            submenuLabel: {
                padding: '{navigation.submenu.label.padding}',
                fontWeight: '{navigation.submenu.label.font.weight}',
                background: '{navigation.submenu.label.background.}',
                color: '{navigation.submenu.label.color}',
            },
            separator: {
                borderColor: '{content.border.color}',
            },
        },
        menubar: {
            root: {
                borderColor: 'transparent',
                borderRadius: '{content.border.radius}',
                color: '{content.color}',
                gap: '0.5rem',
                padding: '0.75rem 1rem',
                transitionDuration: '{transition.duration}',
            },
            baseItem: {
                borderRadius: '{content.border.radius}',
                padding: '0.75rem 1rem',
            },
            item: {
                focusBackground: '{navigation.item.focus.background}',
                activeBackground: '{navigation.item.active.background}',
                color: '{navigation.item.color}',
                focusColor: '{navigation.item.focus.color}',
                activeColor: '{navigation.item.active.color}',
                padding: '{navigation.item.padding}',
                borderRadius: '{navigation.item.border.radius}',
                gap: '{navigation.item.gap}',
                icon: {
                    color: '{navigation.item.icon.color}',
                    focusColor: '{navigation.item.icon.focus.color}',
                    activeColor: '{navigation.item.icon.active.color}',
                },
            },
            submenu: {
                padding: '{navigation.list.padding}',
                gap: '{navigation.list.gap}',
                background: '{content.background}',
                borderColor: '{content.border.color}',
                borderRadius: '{content.border.radius}',
                shadow: '{overlay.navigation.shadow}',
                mobileIndent: '1.25rem',
                icon: {
                    size: '{navigation.submenu.icon.size}',
                    color: '{navigation.submenu.icon.color}',
                    focusColor: '{navigation.submenu.icon.focus.color}',
                    activeColor: '{navigation.submenu.icon.active.color}',
                },
            },
            separator: {
                borderColor: '{content.border.color}',
            },
            mobileButton: {
                borderRadius: '50%',
                size: '2rem',
                color: '{text.muted.color}',
                hoverColor: '{text.hover.muted.color}',
                hoverBackground: '{content.hover.background}',
                focusRing: {
                    width: '{focus.ring.width}',
                    style: '{focus.ring.style}',
                    color: '{focus.ring.color}',
                    offset: '{focus.ring.offset}',
                    shadow: '{focus.ring.shadow}',
                },
            },
            colorScheme: {
                light: {
                    root: {
                        background: '{surface.50}',
                    },
                },
                dark: {
                    root: {
                        background: '{surface.50}',
                    },
                },
            },
        },
        message: {
            root: {
                borderRadius: '{content.border.radius}',
                borderWidth: '1px',
                transitionDuration: '{transition.duration}',
            },
            content: {
                padding: '0.75rem 1rem',
                gap: '0.5rem',
                sm: {
                    padding: '0.5rem 0.625rem',
                },
                lg: {
                    padding: '0.75rem 0.875rem',
                },
            },
            text: {
                fontSize: '1rem',
                fontWeight: '500',
                sm: {
                    fontSize: '0.875rem',
                },
                lg: {
                    fontSize: '1.125rem',
                },
            },
            icon: {
                size: '1.25rem',
                sm: {
                    size: '1rem',
                },
                lg: {
                    size: '1.5rem',
                },
            },
            closeButton: {
                width: '2rem',
                height: '2rem',
                borderRadius: '50%',
                focusRing: {
                    width: '{focus.ring.width}',
                    style: '{focus.ring.style}',
                    offset: '{focus.ring.offset}',
                },
            },
            closeIcon: {
                size: '1rem',
                sm: {
                    size: '0.875rem',
                },
                lg: {
                    size: '1.125rem',
                },
            },
            outlined: {
                root: {
                    borderWidth: '1px',
                },
            },
            simple: {
                content: {
                    padding: '0',
                },
            },
            colorScheme: {
                light: {
                    info: {
                        background: 'color-mix(in srgb, {blue.50}, transparent 5%)',
                        borderColor: 'transparent',
                        color: '{blue.600}',
                        shadow: 'none',
                        closeButton: {
                            hoverBackground: '{blue.100}',
                            focusRing: {
                                color: '{focus.ring.color}',
                                shadow: '0 0 0 0.2rem {blue.200}',
                            },
                        },
                        outlined: {
                            color: '{blue.600}',
                            borderColor: '{blue.600}',
                        },
                        simple: {
                            color: '{blue.600}',
                        },
                    },
                    success: {
                        background: 'color-mix(in srgb, {green.50}, transparent 5%)',
                        borderColor: 'transparent',
                        color: '{green.600}',
                        shadow: 'none',
                        closeButton: {
                            hoverBackground: '{green.100}',
                            focusRing: {
                                color: '{focus.ring.color}',
                                shadow: '0 0 0 0.2rem {green.200}',
                            },
                        },
                        outlined: {
                            color: '{green.600}',
                            borderColor: '{green.600}',
                        },
                        simple: {
                            color: '{green.600}',
                        },
                    },
                    warn: {
                        background: 'color-mix(in srgb,{yellow.50}, transparent 5%)',
                        borderColor: 'transparent',
                        color: '{yellow.600}',
                        shadow: 'none',
                        closeButton: {
                            hoverBackground: '{yellow.100}',
                            focusRing: {
                                color: '{focus.ring.color}',
                                shadow: '0 0 0 0.2rem {yellow.200}',
                            },
                        },
                        outlined: {
                            color: '{yellow.600}',
                            borderColor: '{yellow.600}',
                        },
                        simple: {
                            color: '{yellow.600}',
                        },
                    },
                    error: {
                        background: '{red.500}',
                        borderColor: 'transparent',
                        color: '{neutral.50}',
                        shadow: 'none',
                        closeButton: {
                            hoverBackground: '{red.100}',
                            focusRing: {
                                color: '{focus.ring.color}',
                                shadow: '0 0 0 0.2rem {red.200}',
                            },
                        },
                        outlined: {
                            color: '{red.600}',
                            borderColor: '{red.600}',
                        },
                        simple: {
                            color: '{red.600}',
                        },
                    },
                    secondary: {
                        background: '{surface.100}',
                        borderColor: 'transparent',
                        color: '{surface.600}',
                        shadow: 'none',
                        closeButton: {
                            hoverBackground: '{surface.200}',
                            focusRing: {
                                color: '{focus.ring.color}',
                                shadow: '0 0 0 0.2rem {surface.200}',
                            },
                        },
                        outlined: {
                            color: '{surface.500}',
                            borderColor: '{surface.500}',
                        },
                        simple: {
                            color: '{surface.500}',
                        },
                    },
                    contrast: {
                        background: '{surface.900}',
                        borderColor: 'transparent',
                        color: '{surface.50}',
                        shadow: 'none',
                        closeButton: {
                            hoverBackground: '{surface.800}',
                            focusRing: {
                                color: '{focus.ring.color}',
                                shadow: '0 0 0 0.2rem {surface.400}',
                            },
                        },
                        outlined: {
                            color: '{surface.900}',
                            borderColor: '{surface.900}',
                        },
                        simple: {
                            color: '{surface.900}',
                        },
                    },
                },
                dark: {
                    info: {
                        background: 'color-mix(in srgb, {blue.50}, transparent 5%)',
                        borderColor: 'transparent',
                        color: '{blue.600}',
                        shadow: 'none',
                        closeButton: {
                            hoverBackground: '{blue.100}',
                            focusRing: {
                                color: '{focus.ring.color}',
                                shadow: '0 0 0 0.2rem {blue.200}',
                            },
                        },
                        outlined: {
                            color: '{blue.600}',
                            borderColor: '{blue.600}',
                        },
                        simple: {
                            color: '{blue.600}',
                        },
                    },
                    success: {
                        background: 'color-mix(in srgb, {green.50}, transparent 5%)',
                        borderColor: 'transparent',
                        color: '{green.600}',
                        shadow: 'none',
                        closeButton: {
                            hoverBackground: '{green.100}',
                            focusRing: {
                                color: '{focus.ring.color}',
                                shadow: '0 0 0 0.2rem {green.200}',
                            },
                        },
                        outlined: {
                            color: '{green.600}',
                            borderColor: '{green.600}',
                        },
                        simple: {
                            color: '{green.600}',
                        },
                    },
                    warn: {
                        background: 'color-mix(in srgb,{yellow.50}, transparent 5%)',
                        borderColor: 'transparent',
                        color: '{yellow.600}',
                        shadow: 'none',
                        closeButton: {
                            hoverBackground: '{yellow.100}',
                            focusRing: {
                                color: '{focus.ring.color}',
                                shadow: '0 0 0 0.2rem {yellow.200}',
                            },
                        },
                        outlined: {
                            color: '{yellow.600}',
                            borderColor: '{yellow.600}',
                        },
                        simple: {
                            color: '{yellow.600}',
                        },
                    },
                    error: {
                        background: '{red.500}',
                        borderColor: 'transparent',
                        color: '{neutral.50}',
                        shadow: 'none',
                        closeButton: {
                            hoverBackground: '{red.100}',
                            focusRing: {
                                color: '{focus.ring.color}',
                                shadow: '0 0 0 0.2rem {red.200}',
                            },
                        },
                        outlined: {
                            color: '{red.600}',
                            borderColor: '{red.600}',
                        },
                        simple: {
                            color: '{red.600}',
                        },
                    },
                    secondary: {
                        background: '{surface.100}',
                        borderColor: 'transparent',
                        color: '{surface.600}',
                        shadow: 'none',
                        closeButton: {
                            hoverBackground: '{surface.200}',
                            focusRing: {
                                color: '{focus.ring.color}',
                                shadow: '0 0 0 0.2rem {surface.200}',
                            },
                        },
                        outlined: {
                            color: '{surface.500}',
                            borderColor: '{surface.500}',
                        },
                        simple: {
                            color: '{surface.500}',
                        },
                    },
                    contrast: {
                        background: '{surface.900}',
                        borderColor: 'transparent',
                        color: '{surface.50}',
                        shadow: 'none',
                        closeButton: {
                            hoverBackground: '{surface.800}',
                            focusRing: {
                                color: '{focus.ring.color}',
                                shadow: '0 0 0 0.2rem {surface.400}',
                            },
                        },
                        outlined: {
                            color: '{surface.900}',
                            borderColor: '{surface.900}',
                        },
                        simple: {
                            color: '{surface.900}',
                        },
                    },
                },
            },
        },
        metergroup: {
            root: {
                borderRadius: '{content.border.radius}',
                gap: '1rem',
            },
            meters: {
                background: '{content.border.color}',
                size: '0.625rem',
            },
            label: {
                gap: '0.5rem',
            },
            labelMarker: {
                size: '0.5rem',
            },
            labelIcon: {
                size: '1rem',
            },
            labelList: {
                verticalGap: '0.5rem',
                horizontalGap: '1rem',
            },
        },
        multiselect: {
            root: {
                background: '{form.field.background}',
                disabledBackground: '#fff',
                filledBackground: '{form.field.filled.background}',
                filledHoverBackground: '{form.field.filled.hover.background}',
                filledFocusBackground: '{form.field.filled.focus.background}',
                borderColor: '{form.field.border.color}',
                hoverBorderColor: '{form.field.hover.border.color}',
                focusBorderColor: '{form.field.focus.border.color}',
                invalidBorderColor: '{form.field.invalid.border.color}',
                color: '{form.field.color}',
                disabledColor: '{form.field.disabled.color}',
                placeholderColor: '{form.field.placeholder.color}',
                invalidPlaceholderColor: '{form.field.invalid.placeholder.color}',
                shadow: '{form.field.shadow}',
                paddingX: '{form.field.padding.x}',
                paddingY: '{form.field.padding.y}',
                borderRadius: '{form.field.border.radius}',
                focusRing: {
                    width: '{form.field.focus.ring.width}',
                    style: '{form.field.focus.ring.style}',
                    color: '{form.field.focus.ring.color}',
                    offset: '{form.field.focus.ring.offset}',
                    shadow: '{form.field.focus.ring.shadow}',
                },
                transitionDuration: '{form.field.transition.duration}',
                sm: {
                    fontSize: '{form.field.sm.font.size}',
                    paddingX: '{form.field.sm.padding.x}',
                    paddingY: '{form.field.sm.padding.y}',
                },
                lg: {
                    fontSize: '{form.field.lg.font.size}',
                    paddingX: '{form.field.lg.padding.x}',
                    paddingY: '{form.field.lg.padding.y}',
                },
            },
            dropdown: {
                width: '1.8rem',
                color: '{form.field.icon.color}',
            },
            overlay: {
                background: '#fff',
                borderColor: '#d9dedd',
                borderRadius: '{overlay.select.border.radius}',
                color: '{overlay.select.color}',
                shadow: '{overlay.select.shadow}',
            },
            list: {
                padding: '{list.padding}',
                gap: '{list.gap}',
                header: {
                    padding: '.5rem 1rem',
                },
            },
            option: {
                focusBackground: '{list.option.focus.background}',
                selectedBackground: 'none',
                selectedFocusBackground: '{list.option.focus.background}',
                color: '{list.option.color}',
                focusColor: '{list.option.color}',
                selectedColor: '{list.option.color}',
                selectedFocusColor: '{list.option.color}',
                padding: '{list.option.padding}',
                borderRadius: '{list.option.border.radius}',
                gap: '0.5rem',
            },
            optionGroup: {
                background: '{list.option.group.background}',
                color: '{list.option.group.color}',
                fontWeight: '{list.option.group.font.weight}',
                padding: '{list.option.group.padding}',
            },
            clearIcon: {
                color: '{form.field.icon.color}',
            },
            chip: {
                borderRadius: '{border.radius.sm}',
            },
            emptyMessage: {
                padding: '{list.option.padding}',
            },
        },
        orderlist: {
            root: {
                gap: '1.125rem',
            },
            controls: {
                gap: '0.5rem',
            },
        },
        organizationchart: {
            root: {
                gutter: '0.75rem',
                transitionDuration: '{transition.duration}',
            },
            node: {
                background: '{content.background}',
                hoverBackground: '{content.hover.background}',
                selectedBackground: '{highlight.background}',
                borderColor: '{content.border.color}',
                color: '{content.color}',
                selectedColor: '{highlight.color}',
                hoverColor: '{content.hover.color}',
                padding: '1rem 1.25rem',
                toggleablePadding: '1rem 1.25rem 1.5rem 1.25rem',
                borderRadius: '{content.border.radius}',
            },
            nodeToggleButton: {
                background: '{content.background}',
                hoverBackground: '{content.hover.background}',
                borderColor: '{content.border.color}',
                color: '{text.muted.color}',
                hoverColor: '{text.color}',
                size: '1.75rem',
                borderRadius: '50%',
                focusRing: {
                    width: '{focus.ring.width}',
                    style: '{focus.ring.style}',
                    color: '{focus.ring.color}',
                    offset: '{focus.ring.offset}',
                    shadow: '{focus.ring.shadow}',
                },
            },
            connector: {
                color: '{content.border.color}',
                borderRadius: '{content.border.radius}',
                height: '24px',
            },
        },
        overlaybadge: {
            root: {
                outline: {
                    width: '2px',
                    color: '{content.background}',
                },
            },
        },
        popover: {
            root: {
                background: '#fff',
                borderColor: '{overlay.popover.border.color}',
                color: '{overlay.popover.color}',
                borderRadius: '{overlay.popover.border.radius}',
                shadow: '{overlay.popover.shadow}',
                gutter: '10px',
                arrowOffset: '1.25rem',
            },
            content: {
                padding: '{overlay.popover.padding}',
            },
        },
        paginator: {
            root: {
                padding: '0',
                gap: '0.25rem',
                borderRadius: '{content.border.radius}',
                background: '#fff',
                color: '{content.color}',
                transitionDuration: '{transition.duration}',
            },
            navButton: {
                background: 'transparent',
                hoverBackground: '{gray.100}',
                selectedBackground: '{highlight.background}',
                color: '{text.muted.color}',
                hoverColor: '{content.color}',
                selectedColor: '{content.color}',
                width: '40px',
                height: '40px',
                borderRadius: '0',
                focusRing: {
                    width: '{focus.ring.width}',
                    style: '{focus.ring.style}',
                    color: '{focus.ring.color}',
                    offset: '{focus.ring.offset}',
                    shadow: '{focus.ring.shadow}',
                },
            },
            currentPageReport: {
                color: '{text.muted.color}',
            },
            jumpToPageInput: {
                maxWidth: '2.5rem',
            },
        },
        password: {
            meter: {
                background: '{content.border.color}',
                borderRadius: '{content.border.radius}',
                height: '.75rem',
            },
            icon: {
                color: '{form.field.icon.color}',
            },
            overlay: {
                background: '{overlay.popover.background}',
                borderColor: '{overlay.popover.border.color}',
                borderRadius: '{overlay.popover.border.radius}',
                color: '{overlay.popover.color}',
                padding: '{overlay.popover.padding}',
                shadow: '{overlay.popover.shadow}',
            },
            content: {
                gap: '0.75rem',
            },
            colorScheme: {
                light: {
                    strength: {
                        weakBackground: '{red.500}',
                        mediumBackground: '{amber.500}',
                        strongBackground: '{green.500}',
                    },
                },
                dark: {
                    strength: {
                        weakBackground: '{red.500}',
                        mediumBackground: '{amber.500}',
                        strongBackground: '{green.500}',
                    },
                },
            },
        },
        panel: {
            root: {
                borderColor: '{content.border.color}',
                borderRadius: '{content.border.radius}',
            },
            header: {
                borderWidth: '0',
                borderColor: '{content.border.color}',
                padding: '16px',
                borderRadius: '4px 4px 0 0',
            },
            toggleableHeader: {
                padding: '0.25rem 1.125rem',
            },
            title: {
                fontWeight: '500',
            },
            content: {
                padding: '0 16px 16px 16px',
            },
            footer: {
                padding: '16px',
            },
            colorScheme: {
                light: {
                    header: {
                        background: '#fff',
                        color: '{text.color}',
                    },
                },
                dark: {
                    header: {
                        background: '{surface.50}',
                        color: '{text.color}',
                    },
                },
            },
            css: () => `
            .p-panel-content{
                background: #fff
            }
            `,
        },
        panelmenu: {
            root: {
                gap: '0',
                transitionDuration: '{transition.duration}',
            },
            panel: {
                background: 'transparent ',
                borderColor: 'none',
                borderWidth: '0',
                color: '{stone.500}',
                padding: '0',
                borderRadius: '4px',
                first: {
                    borderWidth: '0',
                    topBorderRadius: '0',
                },
                last: {
                    borderWidth: '0',
                    bottomBorderRadius: '0',
                },
            },
            item: {
                focusBackground: 'transparent',
                color: '#f5fcf8',
                focusColor: '#f5fcf8',
                gap: '10px',
                padding: '8px 0',
                borderRadius: '0',
                icon: {
                    color: '#f5fcf8',
                    focusColor: '#f5fcf8',
                },
            },
            submenu: {
                indent: '16px',
            },
            submenuIcon: {
                color: '{stone.500}',
                focusColor: '{stone.500}',
            },
        },
        picklist: {
            root: {
                gap: '1.125rem',
            },
            controls: {
                gap: '0.5rem',
            },
        },
        progressbar: {
            root: {
                background: '{content.border.color}',
                borderRadius: '{content.border.radius}',
                height: '1.5rem',
            },
            value: {
                background: '{primary.color}',
            },
            label: {
                color: '{primary.contrast.color}',
                fontSize: '0.875rem',
                fontWeight: '600',
            },
        },
        progressspinner: {
            colorScheme: {
                light: {
                    root: {
                        colorOne: '{pink.500}',
                        colorTwo: '{sky.500}',
                        colorThree: '{emerald.500}',
                        colorFour: '{amber.500}',
                    },
                },
                dark: {
                    root: {
                        colorOne: '{pink.500}',
                        colorTwo: '{sky.500}',
                        colorThree: '{emerald.500}',
                        colorFour: '{amber.500}',
                    },
                },
            },
        },
        radiobutton: {
            root: {
                width: '1.5rem',
                height: '1.5rem',
                background: '{form.field.background}',
                checkedBackground: '{primary.color}',
                checkedHoverBackground: '{primary.hover.color}',
                disabledBackground: '{form.field.disabled.background}',
                filledBackground: '{form.field.filled.background}',
                borderColor: '{form.field.border.color}',
                hoverBorderColor: '{form.field.hover.border.color}',
                focusBorderColor: '{form.field.focus.border.color}',
                checkedBorderColor: '{primary.color}',
                checkedHoverBorderColor: '{primary.hover.color}',
                checkedFocusBorderColor: '{primary.color}',
                checkedDisabledBorderColor: '{form.field.border.color}',
                invalidBorderColor: '{form.field.invalid.border.color}',
                shadow: '{form.field.shadow}',
                focusRing: {
                    width: '{form.field.focus.ring.width}',
                    style: '{form.field.focus.ring.style}',
                    color: '{form.field.focus.ring.color}',
                    offset: '{form.field.focus.ring.offset}',
                    shadow: '{form.field.focus.ring.shadow}',
                },
                transitionDuration: '{form.field.transition.duration}',
                sm: {
                    width: '1.25rem',
                    height: '1.25rem',
                },
                lg: {
                    width: '1.75rem',
                    height: '1.75rem',
                },
            },
            icon: {
                size: '1rem',
                checkedColor: '{primary.contrast.color}',
                checkedHoverColor: '{primary.contrast.color}',
                disabledColor: '{form.field.disabled.color}',
                sm: {
                    size: '0.75rem',
                },
                lg: {
                    size: '1.25rem',
                },
            },
        },
        rating: {
            root: {
                gap: '0.25rem',
                transitionDuration: '{transition.duration}',
                focusRing: {
                    width: '{focus.ring.width}',
                    style: '{focus.ring.style}',
                    color: '{focus.ring.color}',
                    offset: '{focus.ring.offset}',
                    shadow: '{focus.ring.shadow}',
                },
            },
            icon: {
                size: '1.25rem',
                color: '{text.muted.color}',
                hoverColor: '{primary.color}',
                activeColor: '{primary.color}',
            },
        },
        scrollpanel: {
            root: {
                transitionDuration: '{transition.duration}',
            },
            bar: {
                size: '9px',
                borderRadius: '{border.radius.sm}',
                focusRing: {
                    width: '{focus.ring.width}',
                    style: '{focus.ring.style}',
                    color: '{focus.ring.color}',
                    offset: '{focus.ring.offset}',
                    shadow: '{focus.ring.shadow}',
                },
            },
            colorScheme: {
                light: {
                    bar: {
                        background: '{surface.200}',
                    },
                },
                dark: {
                    bar: {
                        background: '{surface.200}',
                    },
                },
            },
        },
        select: {
            root: {
                background: '{form.field.background}',
                disabledBackground: '{form.field.disabled.background}',
                filledBackground: '{form.field.filled.background}',
                filledHoverBackground: '{form.field.filled.hover.background}',
                filledFocusBackground: '{form.field.filled.focus.background}',
                borderColor: '{form.field.border.color}',
                hoverBorderColor: '{form.field.hover.border.color}',
                focusBorderColor: '{form.field.focus.border.color}',
                invalidBorderColor: '{form.field.invalid.border.color}',
                color: '{form.field.color}',
                disabledColor: '{form.field.color}',
                placeholderColor: '{form.field.color}',
                invalidPlaceholderColor: '{form.field.invalid.placeholder.color}',
                shadow: '{form.field.shadow}',
                paddingX: '{form.field.padding.x}',
                paddingY: '{form.field.padding.y}',
                borderRadius: '{form.field.border.radius}',
                focusRing: {
                    width: '{form.field.focus.ring.width}',
                    style: '{form.field.focus.ring.style}',
                    color: '{form.field.focus.ring.color}',
                    offset: '{form.field.focus.ring.offset}',
                    shadow: '{form.field.focus.ring.shadow}',
                },
                transitionDuration: '{form.field.transition.duration}',
                sm: {
                    fontSize: '{form.field.sm.font.size}',
                    paddingX: '{form.field.sm.padding.x}',
                    paddingY: '{form.field.sm.padding.y}',
                },
                lg: {
                    fontSize: '{form.field.lg.font.size}',
                    paddingX: '{form.field.lg.padding.x}',
                    paddingY: '{form.field.lg.padding.y}',
                },
            },
            dropdown: {
                width: '1.8rem',
                color: '{form.field.icon.color}',
            },
            overlay: {
                background: '{overlay.select.background}',
                borderColor: '{overlay.select.border.color}',
                borderRadius: '{overlay.select.border.radius}',
                color: '{overlay.select.color}',
                shadow: '{overlay.select.shadow}',
            },
            list: {
                padding: '{list.padding}',
                gap: '{list.gap}',
                header: {
                    padding: '.5rem 1rem',
                },
            },
            option: {
                focusBackground: '{gray.200}',
                selectedBackground: '{list.option.selected.background}',
                selectedFocusBackground: '{list.option.selected.background}',
                color: '{list.option.color}',
                focusColor: '{list.option.focus.color}',
                selectedColor: '{list.option.selected.color}',
                selectedFocusColor: '{list.option.selected.color}',
                padding: '{list.option.padding}',
                borderRadius: '{list.option.border.radius}',
            },
            optionGroup: {
                background: '{list.option.group.background}',
                color: '{list.option.group.color}',
                fontWeight: '{list.option.group.font.weight}',
                padding: '{list.option.group.padding}',
            },
            clearIcon: {
                color: '{form.field.icon.color}',
            },
            checkmark: {
                color: '{list.option.color}',
                gutterStart: '-0.5rem',
                gutterEnd: '0.5rem',
            },
            emptyMessage: {
                padding: '{list.option.padding}',
            },
            css: () => `
                .p-select-dropdown .p-iconwrapper {width:10px};
              `,
        },
        selectbutton: {
            root: {
                borderRadius: '{form.field.border.radius}',
            },
            colorScheme: {
                light: {
                    root: {
                        invalidBorderColor: '{form.field.invalid.border.color}',
                    },
                },
                dark: {
                    root: {
                        invalidBorderColor: '{form.field.invalid.border.color}',
                    },
                },
            },
        },
        skeleton: {
            root: {
                borderRadius: '{content.border.radius}',
            },
            colorScheme: {
                light: {
                    root: {
                        background: 'rgba(0,200,0,0.4)',
                        animationBackground: 'rgba(0,0,200,0.4)',
                    },
                },
                dark: {
                    root: {
                        background: 'rgba(0,200,0,0.4)',
                        animationBackground: 'rgba(0,0,200,0.4)',
                    },
                },
            },
        },
        slider: {
            root: {
                transitionDuration: '{transition.duration}',
            },
            track: {
                background: '{slate.200}',
                borderRadius: '{content.border.radius}',
                size: '4px',
            },
            range: {
                background: '{primary.color}',
            },
            handle: {
                width: '16px',
                height: '16px',
                borderRadius: '50%',
                background: '{primary.color}',
                hoverBackground: '{primary.color}',
                content: {
                    borderRadius: '50%',
                    hoverBackground: '{primary.color}',
                    width: '12px',
                    height: '12px',
                    shadow: 'none',
                },
                focusRing: {
                    width: '{form.field.focus.ring.width}',
                    style: '{form.field.focus.ring.style}',
                    color: '{form.field.focus.ring.color}',
                    offset: '{form.field.focus.ring.offset}',
                    shadow: '{form.field.focus.ring.shadow}',
                },
            },
            colorScheme: {
                light: {
                    handle: {
                        content: {
                            background: '{surface.0}',
                        },
                    },
                },
                dark: {
                    handle: {
                        content: {
                            background: '{surface.0}',
                        },
                    },
                },
            },
        },
        speeddial: {
            root: {
                gap: '0.5rem',
                transitionDuration: '{transition.duration}',
            },
        },
        splitter: {
            root: {
                background: '{content.background}',
                borderColor: '{content.border.color}',
                color: '{content.color}',
                transitionDuration: '{transition.duration}',
            },
            gutter: {
                background: '{content.border.color}',
            },
            handle: {
                size: '24px',
                borderRadius: '{content.border.radius}',
                focusRing: {
                    width: '{focus.ring.width}',
                    style: '{focus.ring.style}',
                    color: '{focus.ring.color}',
                    offset: '{focus.ring.offset}',
                    shadow: '{focus.ring.shadow}',
                },
            },
            colorScheme: {
                light: {
                    handle: {
                        background: '{surface.400}',
                    },
                },
                dark: {
                    handle: {
                        background: '{surface.400}',
                    },
                },
            },
        },
        splitbutton: {
            root: {
                borderRadius: '{form.field.border.radius}',
                roundedBorderRadius: '2rem',
                raisedShadow:
                    '0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12)',
            },
        },
        stepper: {
            root: {
                transitionDuration: '{transition.duration}',
            },
            separator: {
                background: '{content.border.color}',
                activeBackground: '{primary.color}',
                margin: '0 0 0 1.625rem',
                size: '2px',
            },
            step: {
                padding: '0.5rem',
                gap: '1rem',
            },
            stepHeader: {
                padding: '0',
                borderRadius: '{content.border.radius}',
                focusRing: {
                    width: '{focus.ring.width}',
                    style: '{focus.ring.style}',
                    color: '{focus.ring.color}',
                    offset: '{focus.ring.offset}',
                    shadow: '{focus.ring.shadow}',
                },
                gap: '0.5rem',
            },
            stepTitle: {
                color: '{text.muted.color}',
                activeColor: '{primary.color}',
                fontWeight: '500',
            },
            stepNumber: {
                background: '{content.background}',
                activeBackground: '{primary.color}',
                borderColor: '{content.border.color}',
                activeBorderColor: '{primary.color}',
                color: '{text.muted.color}',
                activeColor: '{primary.contrast.color}',
                size: '2.25rem',
                fontSize: '1.125rem',
                fontWeight: '500',
                borderRadius: '50%',
                shadow: 'none',
            },
            steppanels: {
                padding: '0.875rem 0.5rem 1.125rem 0.5rem',
            },
            steppanel: {
                background: '{content.background}',
                color: '{content.color}',
                padding: '0',
                indent: '1rem',
            },
        },
        steps: {
            root: {
                transitionDuration: '{transition.duration}',
            },
            separator: {
                background: '{content.border.color}',
            },
            itemLink: {
                borderRadius: '{content.border.radius}',
                focusRing: {
                    width: '{focus.ring.width}',
                    style: '{focus.ring.style}',
                    color: '{focus.ring.color}',
                    offset: '{focus.ring.offset}',
                    shadow: '{focus.ring.shadow}',
                },
                gap: '0.5rem',
            },
            itemLabel: {
                color: '{text.muted.color}',
                activeColor: '{primary.color}',
                fontWeight: '500',
            },
            itemNumber: {
                background: '{content.background}',
                activeBackground: '{primary.color}',
                borderColor: '{content.border.color}',
                activeBorderColor: '{primary.color}',
                color: '{text.muted.color}',
                activeColor: '{primary.contrast.color}',
                size: '2.25rem',
                fontSize: '1.125rem',
                fontWeight: '500',
                borderRadius: '50%',
                shadow: 'none',
            },
        },
        tabmenu: {
            root: {
                transitionDuration: '{transition.duration}',
            },
            tablist: {
                borderWidth: '0',
                background: '{content.background}',
                borderColor: '{content.border.color}',
            },
            item: {
                borderWidth: '2px 0 0 0',
                borderColor: 'transparent',
                hoverBorderColor: 'transparent',
                activeBorderColor: '{primary.color}',
                color: '{text.muted.color}',
                hoverColor: '{text.color}',
                activeColor: '{primary.color}',
                padding: '1rem 1.25rem',
                fontWeight: '600',
                margin: '0',
                gap: '0.5rem',
                focusRing: {
                    width: '{focus.ring.width}',
                    style: '{focus.ring.style}',
                    color: '{focus.ring.color}',
                    offset: '{focus.ring.offset}',
                    shadow: '{focus.ring.shadow}',
                },
            },
            itemIcon: {
                color: '{text.muted.color}',
                hoverColor: '{text.color}',
                activeColor: '{primary.color}',
            },
            activeBar: {
                height: '0',
                bottom: '0',
                background: 'transparent',
            },
            colorScheme: {
                light: {
                    item: {
                        background: '{surface.50}',
                        hoverBackground: '{surface.100}',
                        activeBackground: '{surface.0}',
                    },
                },
                dark: {
                    item: {
                        background: '{surface.50}',
                        hoverBackground: '{surface.100}',
                        activeBackground: '{surface.0}',
                    },
                },
            },
        },
        tabs: {
            root: {
                transitionDuration: '{transition.duration}',
            },
            tablist: {
                borderWidth: '0',
                background: '{content.background}',
                borderColor: '{content.border.color}',
            },
            tab: {
                borderWidth: '2px 0 0 0',
                borderColor: 'transparent',
                hoverBorderColor: 'transparent',
                activeBorderColor: '{primary.color}',
                color: '{text.muted.color}',
                hoverColor: '{text.color}',
                activeColor: '{primary.color}',
                padding: '1rem 1.25rem',
                fontWeight: '700',
                margin: '0',
                focusRing: {
                    width: '{focus.ring.width}',
                    style: '{focus.ring.style}',
                    color: '{focus.ring.color}',
                    offset: '{focus.ring.offset}',
                    shadow: 'inset {focus.ring.shadow}',
                },
            },
            tabpanel: {
                background: '{content.background}',
                color: '{content.color}',
                padding: '0.875rem 1.125rem 1.125rem 1.125rem',
                focusRing: {
                    width: '{focus.ring.width}',
                    style: '{focus.ring.style}',
                    color: '{focus.ring.color}',
                    offset: '{focus.ring.offset}',
                    shadow: 'inset {focus.ring.shadow}',
                },
            },
            navButton: {
                background: '{content.background}',
                color: '{text.muted.color}',
                hoverColor: '{text.color}',
                width: '2.5rem',
                focusRing: {
                    width: '{focus.ring.width}',
                    style: '{focus.ring.style}',
                    color: '{focus.ring.color}',
                    offset: '{focus.ring.offset}',
                    shadow: 'inset {focus.ring.shadow}',
                },
            },
            activeBar: {
                height: '0',
                bottom: '0',
                background: 'transparent',
            },
            colorScheme: {
                light: {
                    navButton: {
                        shadow: '0px 0px 10px 50px rgba(255, 255, 255, 0.6)',
                    },
                    tab: {
                        background: '{surface.50}',
                        hoverBackground: '{surface.100}',
                        activeBackground: '{surface.0}',
                    },
                },
                dark: {
                    navButton: {
                        shadow: '0px 0px 10px 50px rgba(255, 255, 255, 0.6)',
                    },
                    tab: {
                        background: '{surface.50}',
                        hoverBackground: '{surface.100}',
                        activeBackground: '{surface.0}',
                    },
                },
            },
        },
        tabview: {
            root: {
                transitionDuration: '{transition.duration}',
            },
            tabList: {
                background: '{content.background}',
                borderColor: '{content.border.color}',
            },
            tab: {
                borderColor: '{content.border.color}',
                activeBorderColor: '{primary.color}',
                color: '{text.muted.color}',
                hoverColor: '{text.color}',
                activeColor: '{primary.color}',
            },
            tabPanel: {
                background: '{content.background}',
                color: '{content.color}',
            },
            navButton: {
                background: '{content.background}',
                color: '{text.muted.color}',
                hoverColor: '{text.color}',
            },
            colorScheme: {
                light: {
                    navButton: {
                        shadow: '0px 0px 10px 50px rgba(255, 255, 255, 0.6)',
                    },
                },
                dark: {
                    navButton: {
                        shadow: '0px 0px 10px 50px rgba(255, 255, 255, 0.6)',
                    },
                },
            },
        },
        textarea: {
            root: {
                background: '{form.field.background}',
                disabledBackground: '{form.field.disabled.background}',
                filledBackground: '{form.field.filled.background}',
                filledFocusBackground: '{form.field.filled.focus.background}',
                borderColor: '{form.field.border.color}',
                hoverBorderColor: '{form.field.hover.border.color}',
                focusBorderColor: '{form.field.focus.border.color}',
                invalidBorderColor: '{form.field.invalid.border.color}',
                color: '{form.field.color}',
                disabledColor: '{form.field.disabled.color}',
                placeholderColor: '{form.field.placeholder.color}',
                invalidPlaceholderColor: '{form.field.invalid.placeholder.color}',
                shadow: '{form.field.shadow}',
                paddingX: '{form.field.padding.x}',
                paddingY: '{form.field.padding.y}',
                borderRadius: '{form.field.border.radius}',
                focusRing: {
                    width: '{form.field.focus.ring.width}',
                    style: '{form.field.focus.ring.style}',
                    color: '{form.field.focus.ring.color}',
                    offset: '{form.field.focus.ring.offset}',
                    shadow: '{form.field.focus.ring.shadow}',
                },
                transitionDuration: '{form.field.transition.duration}',
                sm: {
                    fontSize: '{form.field.sm.font.size}',
                    paddingX: '{form.field.sm.padding.x}',
                    paddingY: '{form.field.sm.padding.y}',
                },
                lg: {
                    fontSize: '{form.field.lg.font.size}',
                    paddingX: '{form.field.lg.padding.x}',
                    paddingY: '{form.field.lg.padding.y}',
                },
            },
        },
        tieredmenu: {
            root: {
                background: '{content.background}',
                borderColor: '{content.border.color}',
                color: '{content.color}',
                borderRadius: '{content.border.radius}',
                shadow: '{overlay.navigation.shadow}',
                transitionDuration: '{transition.duration}',
            },
            list: {
                padding: '0',
                gap: '{navigation.list.gap}',
            },
            item: {
                focusBackground: '{gray.200}',
                activeBackground: '{navigation.item.active.background}',
                color: '{navigation.item.color}',
                focusColor: '{navigation.item.focus.color}',
                activeColor: '{navigation.item.active.color}',
                padding: '{navigation.item.padding}',
                borderRadius: '{navigation.item.border.radius}',
                gap: '{navigation.item.gap}',
                icon: {
                    color: '{navigation.item.icon.color}',
                    focusColor: '{navigation.item.icon.focus.color}',
                    activeColor: '{navigation.item.icon.active.color}',
                },
            },
            submenu: {
                mobileIndent: '1.25rem',
            },
            submenuIcon: {
                size: '{navigation.submenu.icon.size}',
                color: '{navigation.submenu.icon.color}',
                focusColor: '{navigation.submenu.icon.focus.color}',
                activeColor: '{navigation.submenu.icon.active.color}',
            },
            separator: {
                borderColor: '{content.border.color}',
            },
        },
        tag: {
            root: {
                fontSize: '0.875rem',
                fontWeight: '700',
                padding: '0.25rem 0.5rem',
                gap: '0.25rem',
                borderRadius: '{content.border.radius}',
                roundedBorderRadius: '{border.radius.xl}',
            },
            icon: {
                size: '0.75rem',
            },
            colorScheme: {
                light: {
                    primary: {
                        background: '{primary.color}',
                        color: '{primary.contrast.color}',
                    },
                    secondary: {
                        background: '{surface.100}',
                        color: '{surface.600}',
                    },
                    success: {
                        background: '{green.500}',
                        color: '{surface.0}',
                    },
                    info: {
                        background: '{sky.500}',
                        color: '{surface.0}',
                    },
                    warn: {
                        background: '{orange.500}',
                        color: '{surface.0}',
                    },
                    danger: {
                        background: '{red.700}',
                        color: '{surface.0}',
                    },
                    contrast: {
                        background: '{surface.950}',
                        color: '{surface.0}',
                    },
                },
                dark: {
                    primary: {
                        background: '{primary.color}',
                        color: '{primary.contrast.color}',
                    },
                    secondary: {
                        background: '{surface.100}',
                        color: '{surface.600}',
                    },
                    success: {
                        background: '{green.500}',
                        color: '{surface.0}',
                    },
                    info: {
                        background: '{sky.500}',
                        color: '{surface.0}',
                    },
                    warn: {
                        background: '{orange.500}',
                        color: '{surface.0}',
                    },
                    danger: {
                        background: '{red.500}',
                        color: '{surface.0}',
                    },
                    contrast: {
                        background: '{surface.950}',
                        color: '{surface.0}',
                    },
                },
            },
        },
        terminal: {
            root: {
                background: '{form.field.background}',
                borderColor: '{form.field.border.color}',
                color: '{form.field.color}',
                height: '18rem',
                padding: '{form.field.padding.y} {form.field.padding.x}',
                borderRadius: '{form.field.border.radius}',
            },
            prompt: {
                gap: '0.25rem',
            },
            commandResponse: {
                margin: '2px 0',
            },
        },
        timeline: {
            event: {
                minHeight: '5rem',
            },
            horizontal: {
                eventContent: {
                    padding: '1rem 0',
                },
            },
            vertical: {
                eventContent: {
                    padding: '0 1rem',
                },
            },
            eventMarker: {
                size: '1.125rem',
                borderRadius: '50%',
                borderWidth: '2px',
                background: '{content.background}',
                borderColor: '{primary.color}',
                content: {
                    borderRadius: '50%',
                    size: '0.375rem',
                    background: 'transparent',
                    insetShadow: 'none',
                },
            },
            eventConnector: {
                color: '{content.border.color}',
                size: '2px',
            },
        },
        togglebutton: {
            root: {
                padding: '10px',
                borderRadius: '{content.border.radius}',
                gap: '0.5rem',
                fontWeight: '400',
                background: '{form.field.background}',
                borderColor: '{form.field.border.color}',
                color: '{form.field.color}',
                hoverColor: '{form.field.color}',
                checkedBackground: '{highlight.background}',
                checkedColor: '#151e1c',
                checkedBorderColor: '{form.field.border.color}',
                disabledBackground: '{form.field.disabled.background}',
                disabledBorderColor: '{form.field.disabled.background}',
                disabledColor: '{form.field.disabled.color}',
                invalidBorderColor: '{form.field.invalid.border.color}',
                focusRing: {
                    width: '{form.field.focus.ring.width}',
                    style: '{form.field.focus.ring.style}',
                    color: '{form.field.focus.ring.color}',
                    offset: '{form.field.focus.ring.offset}',
                    shadow: '{form.field.focus.ring.shadow}',
                },
                transitionDuration: '{form.field.transition.duration}',
                sm: {
                    fontSize: '{form.field.sm.font.size}',
                    padding: '0.5rem 0.75rem',
                },
                lg: {
                    fontSize: '{form.field.lg.font.size}',
                    padding: '0.75rem 1.25rem',
                },
            },
            icon: {
                color: '{text.muted.color}',
                hoverColor: '{text.muted.color}',
                checkedColor: '{highlight.color}',
                disabledColor: '{form.field.disabled.color}',
            },
            content: {
                padding: '0',
                checkedBackground: 'transparent',
                checkedShadow: 'none',
            },
            colorScheme: {
                light: {
                    root: {
                        hoverBackground: '{gray.100}',
                    },
                },
                dark: {
                    root: {
                        hoverBackground: '{blue.100}',
                    },
                },
            },
        },
        tree: {
            root: {
                background: '{content.background}',
                color: '{content.color}',
                padding: '1rem',
                gap: '2px',
                indent: '1rem',
                transitionDuration: '{transition.duration}',
            },
            node: {
                padding: '0.375rem 0.625rem',
                borderRadius: '{content.border.radius}',
                hoverBackground: '{content.hover.background}',
                selectedBackground: '{highlight.background}',
                color: '{text.color}',
                hoverColor: '{text.hover.color}',
                selectedColor: '{highlight.color}',
                focusRing: {
                    width: '{focus.ring.width}',
                    style: '{focus.ring.style}',
                    color: '{focus.ring.color}',
                    offset: '{focus.ring.offset}',
                    shadow: 'inset {focus.ring.shadow}',
                },
                gap: '0.25rem',
            },
            nodeIcon: {
                color: '{text.muted.color}',
                hoverColor: '{text.hover.muted.color}',
                selectedColor: '{highlight.color}',
            },
            nodeToggleButton: {
                borderRadius: '50%',
                size: '1.75rem',
                hoverBackground: '{content.hover.background}',
                selectedHoverBackground: '{content.background}',
                color: '{text.muted.color}',
                hoverColor: '{text.hover.muted.color}',
                selectedHoverColor: '{primary.color}',
                focusRing: {
                    width: '{focus.ring.width}',
                    style: '{focus.ring.style}',
                    color: '{focus.ring.color}',
                    offset: '{focus.ring.offset}',
                    shadow: '{focus.ring.shadow}',
                },
            },
            loadingIcon: {
                size: '2rem',
            },
            filter: {
                margin: '0 0 0.5rem 0',
            },
        },
        treeselect: {
            root: {
                background: '{form.field.background}',
                disabledBackground: '{form.field.disabled.background}',
                filledBackground: '{form.field.filled.background}',
                filledHoverBackground: '{form.field.filled.hover.background}',
                filledFocusBackground: '{form.field.filled.focus.background}',
                borderColor: '{form.field.border.color}',
                hoverBorderColor: '{form.field.hover.border.color}',
                focusBorderColor: '{form.field.focus.border.color}',
                invalidBorderColor: '{form.field.invalid.border.color}',
                color: '{form.field.color}',
                disabledColor: '{form.field.disabled.color}',
                placeholderColor: '{form.field.placeholder.color}',
                invalidPlaceholderColor: '{form.field.invalid.placeholder.color}',
                shadow: '{form.field.shadow}',
                paddingX: '{form.field.padding.x}',
                paddingY: '{form.field.padding.y}',
                borderRadius: '{form.field.border.radius}',
                focusRing: {
                    width: '{form.field.focus.ring.width}',
                    style: '{form.field.focus.ring.style}',
                    color: '{form.field.focus.ring.color}',
                    offset: '{form.field.focus.ring.offset}',
                    shadow: '{form.field.focus.ring.shadow}',
                },
                transitionDuration: '{form.field.transition.duration}',
                sm: {
                    fontSize: '{form.field.sm.font.size}',
                    paddingX: '{form.field.sm.padding.x}',
                    paddingY: '{form.field.sm.padding.y}',
                },
                lg: {
                    fontSize: '{form.field.lg.font.size}',
                    paddingX: '{form.field.lg.padding.x}',
                    paddingY: '{form.field.lg.padding.y}',
                },
            },
            dropdown: {
                width: '2.5rem',
                color: '{form.field.icon.color}',
            },
            overlay: {
                background: '{overlay.select.background}',
                borderColor: '{overlay.select.border.color}',
                borderRadius: '{overlay.select.border.radius}',
                color: '{overlay.select.color}',
                shadow: '{overlay.select.shadow}',
            },
            tree: {
                padding: '{list.padding}',
            },
            clearIcon: {
                color: '{form.field.icon.color}',
            },
            emptyMessage: {
                padding: '{list.option.padding}',
            },
            chip: {
                borderRadius: '{border.radius.sm}',
            },
        },
        treetable: {
            root: {
                transitionDuration: '{transition.duration}',
            },
            header: {
                borderColor: '{treetable.border.color}',
                borderWidth: '1px 0 1px 0',
                padding: '0.75rem 1rem',
            },
            headerCell: {
                selectedBackground: '{highlight.background}',
                borderColor: '{treetable.border.color}',
                hoverColor: '{content.hover.color}',
                selectedColor: '{highlight.color}',
                gap: '0.5rem',
                padding: '0.75rem 1rem',
                focusRing: {
                    width: '{focus.ring.width}',
                    style: '{focus.ring.style}',
                    color: '{focus.ring.color}',
                    offset: '{focus.ring.offset}',
                    shadow: 'inset {focus.ring.shadow}',
                },
            },
            columnTitle: {
                fontWeight: '700',
            },
            row: {
                background: '{content.background}',
                hoverBackground: '{content.hover.background}',
                selectedBackground: '{highlight.background}',
                color: '{content.color}',
                hoverColor: '{sr.hover.color}',
                selectedColor: '{highlight.color}',
                focusRing: {
                    width: '{focus.ring.width}',
                    style: '{focus.ring.style}',
                    color: '{focus.ring.color}',
                    offset: '{focus.ring.offset}',
                    shadow: 'inset {focus.ring.shadow}',
                },
            },
            bodyCell: {
                borderColor: '{treetable.border.color}',
                padding: '0.75rem 1rem',
                gap: '0.5rem',
            },
            footerCell: {
                borderColor: '{treetable.border.color}',
                padding: '0.75rem 1rem',
            },
            columnFooter: {
                fontWeight: '700',
            },
            footer: {
                borderColor: '{treetable.border.color}',
                borderWidth: '0 0 1px 0',
                padding: '0.75rem 1rem',
            },
            resizeIndicator: {
                width: '1px',
                color: '{primary.color}',
            },
            sortIcon: {
                color: '{text.muted.color}',
                hoverColor: '{text.hover.muted.color}',
                size: '0.875rem',
            },
            loadingIcon: {
                size: '2rem',
            },
            nodeToggleButton: {
                hoverBackground: '{content.hover.background}',
                selectedHoverBackground: '{content.background}',
                color: '{text.muted.color}',
                hoverColor: '{text.color}',
                selectedHoverColor: '{primary.color}',
                size: '1.75rem',
                borderRadius: '50%',
                focusRing: {
                    width: '{focus.ring.width}',
                    style: '{focus.ring.style}',
                    color: '{focus.ring.color}',
                    offset: '{focus.ring.offset}',
                    shadow: '{focus.ring.shadow}',
                },
            },
            paginatorTop: {
                borderColor: '{content.border.color}',
                borderWidth: '0 0 1px 0',
            },
            paginatorBottom: {
                borderColor: '{content.border.color}',
                borderWidth: '0 0 1px 0',
            },
            colorScheme: {
                light: {
                    root: {
                        borderColor: '{content.border.color}',
                    },
                    header: {
                        background: '{surface.50}',
                        color: '{text.color}',
                    },
                    headerCell: {
                        background: '{surface.50}',
                        hoverBackground: '{surface.100}',
                        color: '{text.color}',
                    },
                    footer: {
                        background: '{surface.50}',
                        color: '{text.color}',
                    },
                    footerCell: {
                        background: '{surface.50}',
                        color: '{text.color}',
                    },
                    bodyCell: {
                        selectedBorderColor: '{primary.100}',
                    },
                },
                dark: {
                    root: {
                        borderColor: '{content.border.color}',
                    },
                    header: {
                        background: '{surface.50}',
                        color: '{text.color}',
                    },
                    headerCell: {
                        background: '{surface.50}',
                        hoverBackground: '{surface.100}',
                        color: '{text.color}',
                    },
                    footer: {
                        background: '{surface.50}',
                        color: '{text.color}',
                    },
                    footerCell: {
                        background: '{surface.50}',
                        color: '{text.color}',
                    },
                    bodyCell: {
                        selectedBorderColor: '{primary.100}',
                    },
                },
            },
        },
        toast: {
            root: {
                width: '25rem',
                borderRadius: '{content.border.radius}',
                borderWidth: '0',
                transitionDuration: '{transition.duration}',
            },
            icon: {
                size: '1.25rem',
            },
            content: {
                padding: '{overlay.popover.padding}',
                gap: '6px',
            },
            text: {
                gap: '6px',
            },
            summary: {
                fontWeight: '500',
                fontSize: '14px',
            },
            detail: {
                fontWeight: '400',
                fontSize: '12px',
            },
            closeButton: {
                width: '24px',
                height: '24px',
                borderRadius: '0',
                focusRing: {
                    width: '0',
                    style: '{focus.ring.style}',
                    offset: '{focus.ring.offset}',
                },
            },
            closeIcon: {
                size: '1rem',
            },

            colorScheme: {
                light: {
                    root: {
                        blur: '0',
                    },
                    info: {
                        background: '#fff',
                        borderColor: '#fff',
                        color: '#1C2231',
                        detailColor: '#1C2231',
                        shadow: '0 2px 4px 0 rgba(4, 23, 59, 0.15);',
                        closeButton: {
                            hoverBackground: '#F7F8F7',
                            focusRing: {
                                color: '#fff',
                                shadow: 'none',
                            },
                        },
                    },
                    success: {
                        background: '#fff',
                        borderColor: '#fff',
                        color: '#1C2231',
                        detailColor: '#1C2231',
                        shadow: '0 2px 4px 0 rgba(4, 23, 59, 0.15);',
                        closeButton: {
                            hoverBackground: '#F7F8F7',
                            focusRing: {
                                color: '#fff',
                                shadow: 'none',
                            },
                        },
                    },
                    warn: {
                        background: '#fff',
                        borderColor: '#fff',
                        color: '#1C2231',
                        detailColor: '#1C2231',
                        shadow: '0 2px 4px 0 rgba(4, 23, 59, 0.15);',
                        closeButton: {
                            hoverBackground: '#F7F8F7',
                            focusRing: {
                                color: '#fff',
                                shadow: 'none',
                            },
                        },
                    },
                    error: {
                        background: '#fff',
                        borderColor: '#fff',
                        color: '#1C2231',
                        detailColor: '#1C2231',
                        shadow: '0 2px 4px 0 rgba(4, 23, 59, 0.15);',
                        closeButton: {
                            hoverBackground: '#F7F8F7',
                            focusRing: {
                                color: '#fff',
                                shadow: 'none',
                            },
                        },
                    },
                    secondary: {
                        background: '#fff',
                        borderColor: '#fff',
                        color: '#1C2231',
                        detailColor: '#1C2231',
                        shadow: '0 2px 4px 0 rgba(4, 23, 59, 0.15);',
                        closeButton: {
                            hoverBackground: '#F7F8F7',
                            focusRing: {
                                color: '#fff',
                                shadow: 'none',
                            },
                        },
                    },
                    contrast: {
                        background: '#fff',
                        borderColor: '#fff',
                        color: '#1C2231',
                        detailColor: '#1C2231',
                        shadow: '0 2px 4px 0 rgba(4, 23, 59, 0.15);',
                        closeButton: {
                            hoverBackground: '#F7F8F7',
                            focusRing: {
                                color: '#fff',
                                shadow: 'none',
                            },
                        },
                    },
                },
            },
        },
        toolbar: {
            root: {
                background: '{content.background}',
                borderColor: '{content.border.color}',
                borderRadius: '{content.border.radius}',
                color: '{content.color}',
                gap: '0.5rem',
                padding: '0.75rem',
            },
            colorScheme: {
                light: {
                    root: {
                        background: '{surface.50}',
                        color: '{content.color}',
                    },
                },
                dark: {
                    root: {
                        background: '{surface.50}',
                        color: '{content.color}',
                    },
                },
            },
        },
        virtualscroller: {
            loader: {
                mask: {
                    background: '{content.background}',
                    color: '{text.muted.color}',
                },
                icon: {
                    size: '2rem',
                },
            },
        },
        tooltip: {
            root: {
                maxWidth: '20rem',
                gutter: '0.35rem',
                shadow: '{overlay.popover.shadow}',
                padding: '0.625rem 0.75rem',
                borderRadius: '{overlay.popover.border.radius}',
            },
            colorScheme: {
                light: {
                    root: {
                        background: '#374E46',
                        color: '#F5FCF8',
                    },
                },
                dark: {
                    root: {
                        background: '#374E46',
                        color: '#F5FCF8',
                    },
                },
            },
        },
        ripple: {
            colorScheme: {
                light: {
                    root: {
                        background: 'rgba(0,0,0,0.1)',
                    },
                },
                dark: {
                    root: {
                        background: 'rgba(0,0,0,0.1)',
                    },
                },
            },
        },
    },
});
